/* FF widget visibility state: keep global CSS free of descendant :has() guards.
   Attribute-only state reads; no polling, geometry reads or app API calls. */
(function () {
  'use strict';

  function initWidgetVisibilityState() {
    const body = document.body;
    if (!body || window.__ffWidgetVisibilityStateV1) return;
    window.__ffWidgetVisibilityStateV1 = true;

    const selector = '#cart-drawer, .ff-legal-guarantee-modal';
    const tracked = new Set(body.querySelectorAll(selector));

    function sync() {
      let cartOpen = false;
      let guaranteeOpen = false;
      tracked.forEach(function (node) {
        if (!body.contains(node) || !node.matches(selector)) {
          tracked.delete(node);
          return;
        }
        if (node.id === 'cart-drawer' && node.hasAttribute('open')) cartOpen = true;
        if (node.matches('.ff-legal-guarantee-modal.is-active')) guaranteeOpen = true;
      });
      if (body.hasAttribute('data-ff-cart-drawer-open') !== cartOpen) {
        body.toggleAttribute('data-ff-cart-drawer-open', cartOpen);
      }
      if (body.hasAttribute('data-ff-legal-guarantee-open') !== guaranteeOpen) {
        body.toggleAttribute('data-ff-legal-guarantee-open', guaranteeOpen);
      }
    }

    function collect(node) {
      if (node.nodeType !== 1) return false;
      let found = false;
      if (node.matches(selector)) {
        tracked.add(node);
        found = true;
      }
      node.querySelectorAll(selector).forEach(function (match) {
        tracked.add(match);
        found = true;
      });
      return found;
    }

    const observer = new MutationObserver(function (records) {
      let dirty = false;
      let removed = false;
      records.forEach(function (record) {
        if (record.type === 'attributes') {
          if (tracked.has(record.target) || record.target.matches(selector)) {
            tracked.add(record.target);
            dirty = true;
          }
        } else {
          record.addedNodes.forEach(function (node) {
            if (collect(node)) dirty = true;
          });
          if (record.removedNodes.length) removed = true;
        }
      });
      if (removed) {
        tracked.forEach(function (node) {
          if (!body.contains(node)) {
            tracked.delete(node);
            dirty = true;
          }
        });
      }
      if (dirty) sync();
    });
    observer.observe(body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open', 'class', 'id']
    });
    sync();
  }

  if (document.body) initWidgetVisibilityState();
  else document.addEventListener('DOMContentLoaded', initWidgetVisibilityState, { once: true });
})();


/* FF UI primitives + small enhancements
   Safe to load alongside stock theme.js.
   Only touches [data-ff-*] hooks + wraps .prose tables.
   + supports deferred secondary product-card images (defer_secondary) */

(function () {
  let ffIdCounter = 0;
  function nextId(prefix) {
    ffIdCounter += 1;
    return prefix + "-" + ffIdCounter;
  }

  // Query selectorAll + include root if it matches
  function qsa(root, selector) {
    const scope = root && root.querySelectorAll ? root : document;
    const nodes = Array.from(scope.querySelectorAll(selector));
    if (scope !== document && scope.nodeType === 1 && scope.matches && scope.matches(selector)) {
      nodes.unshift(scope);
    }
    return nodes;
  }

  const FF_INIT_SELECTOR = [
    ".prose table",
    "product-card[data-ff-secondary-deferred]",
    "[data-ff-tabs]",
    "[data-ff-accordion]",
    "[data-ff-header]",
    "[data-ff-announce]",
    "[data-ff-pf-root]",
    "[data-ff-order-perks]",
    "[data-ff-main-product]",
    "[data-ff-backtotop]",
    "[data-ff-light-parallax]",
    "[data-ff-quick-access]",
    "[data-ff-tabs-parallax]",
    "[data-ff-parallax-multi-column]",
    "[data-ff-care-blog]",
    "[data-ff-richtext-collapsible]",
    "[data-ff-newsletter-popup-success]",
    "[data-ff-header-sidebar-accordions]",
    "[data-ff-collection-banner]",
    "[data-ff-collection-banner-grid]",
    "[data-collapsible-description]",
    "[data-ff-filter-modal]",
    "[data-ff-parallax-root]",
    "[data-ff-submit-on-change]",
    "[data-ff-select-on-click]",
    "[data-ff-print-trigger]",
    "[data-ff-row-link]",
    "[data-ff-scroll-story]",
    "quantity-selector",
    "recently-viewed-products",
    ".ff-blog-posts-list--presentation-parallax_page_cards",
    ".ff-informative-card-grid--presentation-parallax_page_cards",
    ".ff-feature-tiles-section--presentation-parallax_page_cards"
  ].join(",");

  const FF_PARALLAX_PAGE_CARDS_SELECTOR = [
    ".ff-blog-posts-list--presentation-parallax_page_cards",
    ".ff-informative-card-grid--presentation-parallax_page_cards",
    ".ff-feature-tiles-section--presentation-parallax_page_cards"
  ].join(",");

  function nodeMatchesOrContains(node, selector) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches(selector)) return true;
    return !!(node.querySelector && node.querySelector(selector));
  }

  function collectInitRoot(node, bucket) {
    if (!node) return;

    if (node.nodeType === 1) {
      if (nodeMatchesOrContains(node, FF_INIT_SELECTOR)) bucket.add(node);
      return;
    }

    if (node.nodeType === 11 && node.childNodes) {
      node.childNodes.forEach((child) => collectInitRoot(child, bucket));
    }
  }

  function registerCleanup(node, fn) {
    if (!node || node.nodeType !== 1 || typeof fn !== "function") return;

    if (!node.__ffCleanups) node.__ffCleanups = [];
    node.__ffCleanups.push(fn);
    node.setAttribute("data-ff-cleanup-root", "true");
  }

  function runCleanup(node) {
    if (!node || node.nodeType !== 1) return;

    const targets = [];

    if (node.hasAttribute && node.hasAttribute("data-ff-cleanup-root")) {
      targets.push(node);
    }

    if (node.querySelectorAll) {
      node.querySelectorAll("[data-ff-cleanup-root]").forEach((target) => {
        targets.push(target);
      });
    }

    targets.forEach((target) => {
      const cleanups = target.__ffCleanups;
      if (!cleanups || !cleanups.length) return;

      cleanups.forEach((cleanup) => {
        try {
          cleanup();
        } catch (_) {}
      });

      delete target.__ffCleanups;
      target.removeAttribute("data-ff-cleanup-root");
    });
  }

  /* =============================
     PROSE TABLE SCROLLER (dynamic)
     - DOM-safe (no outerHTML)
  ============================== */
  function wrapProseTables(root) {
    qsa(root, ".prose table").forEach((table) => {
      const existingWrapper = table.closest(".table-scroller, .ff-table-scroll, .ff-table-wrap");

      if (existingWrapper) {
        if (table.classList.contains("ff-media-table")) {
          existingWrapper.classList.add("ff-table-scroll--media-table");
        }
        return;
      }

      const wrapper = document.createElement("div");
      wrapper.className = table.closest("[data-ff-main-article]") ? "ff-table-scroll" : "table-scroller";

      const parent = table.parentNode;
      if (!parent) return;

      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);

      if (table.classList.contains("ff-media-table")) {
        wrapper.classList.add("ff-table-scroll--media-table");
      }
    });
  }

  function markFfPresentationShells(root) {
    qsa(root, ".shopify-section").forEach((section) => {
      section.classList.toggle(
        "ff-section--parallax-page-cards",
        !!section.querySelector(FF_PARALLAX_PAGE_CARDS_SELECTOR)
      );
    });

    qsa(root, FF_PARALLAX_PAGE_CARDS_SELECTOR).forEach((sectionRoot) => {
      const shell = sectionRoot.closest(".shopify-section");
      if (shell) shell.classList.add("ff-section--parallax-page-cards");
    });
  }

  function initFfRecentlyViewedSections(root) {
    qsa(root, "recently-viewed-products").forEach((element) => {
      if (element.dataset.ffRecentlyViewedInit === "true") return;
      element.dataset.ffRecentlyViewedInit = "true";

      const shell = element.closest(".shopify-section--ff-recently-viewed-products");
      if (!shell) return;

      const sync = () => {
        shell.classList.toggle("ff-recently-viewed-products-empty", element.childElementCount === 0);
      };

      sync();

      if (!("MutationObserver" in window)) return;

      const observer = new MutationObserver(sync);
      observer.observe(element, { childList: true });

      registerCleanup(element, () => {
        observer.disconnect();
        delete element.dataset.ffRecentlyViewedInit;
      });
    });
  }

  /* =========================================
     PRODUCT CARD: DEFERRED SECONDARY IMAGE LOADER
     - works with ff-product-card defer_secondary output
     - loads on intent (hover/focus/touch)
     - prevents blank hover swap until secondary finishes loading
  ========================================== */
  function initFfDeferredSecondaryImages(root) {
  qsa(root, "product-card[data-ff-secondary-deferred]").forEach((card) => {
    if (card.dataset.ffSecondaryInit === "1") return;
    card.dataset.ffSecondaryInit = "1";

    const loadDeferredSecondary = () => {
      // Re-query every time (images can be replaced by swatches / rerenders)
      const secondary = card.querySelector(
        'img.product-card__image--secondary[data-src], img.product-card__image--secondary[data-srcset], img.product-card__image--secondary[data-sizes]'
      );

      // If there is no deferred secondary anymore, remove the "deferred" marker and bail
      if (!secondary) {
        card.removeAttribute("data-ff-secondary-deferred");
        return;
      }

      // Mark: this card uses deferred secondary (lets CSS block blank hover swap)
      card.setAttribute("data-ff-secondary-deferred", "true");

      // IMPORTANT: if the secondary image got replaced, "ready" must be reset
      card.removeAttribute("data-ff-secondary-ready");

      // Per-image guard (if the img node changes later, the new one can load)
      if (secondary.dataset.ffDeferredLoaded === "1") return;
      secondary.dataset.ffDeferredLoaded = "1";

      const primary = card.querySelector("img.product-card__image--primary");

      // Keep primary visible while secondary loads
      if (primary) primary.style.opacity = "1";
      secondary.style.opacity = "0";

      let settled = false;

      const finalize = () => {
        if (settled) return;
        settled = true;

        card.setAttribute("data-ff-secondary-ready", "true");
        card.removeAttribute("data-ff-secondary-deferred");

        if (primary) primary.style.removeProperty("opacity");
        secondary.style.removeProperty("opacity");

        // Remove data-* after load
        secondary.removeAttribute("data-src");
        secondary.removeAttribute("data-srcset");
        secondary.removeAttribute("data-sizes");
      };

      const fail = () => {
        // Keep primary visible, allow retry later
        if (settled) return;
        settled = true;

        if (primary) primary.style.removeProperty("opacity");
        secondary.style.removeProperty("opacity");

        delete secondary.dataset.ffDeferredLoaded;
        card.removeAttribute("data-ff-secondary-ready");
      };

      secondary.addEventListener("load", finalize, { once: true });
      secondary.addEventListener("error", fail, { once: true });

      // Start request
      const ds = secondary.dataset || {};
      try {
        secondary.decoding = "async";
        if ("fetchPriority" in secondary) secondary.fetchPriority = "low";
      } catch (_) {}

      secondary.removeAttribute("loading");

      if (ds.sizes) secondary.sizes = ds.sizes;
      if (ds.srcset) secondary.srcset = ds.srcset;
      if (ds.src) secondary.src = ds.src;

      // Cached image safety
      if (secondary.complete && secondary.naturalWidth > 0) {
        requestAnimationFrame(finalize);
      }
    };

    card.addEventListener("pointerenter", loadDeferredSecondary, { passive: true });
    card.addEventListener("focusin", loadDeferredSecondary);
    card.addEventListener("touchstart", loadDeferredSecondary, { passive: true });
    card.addEventListener("ff:load-secondary", loadDeferredSecondary);

    registerCleanup(card, () => {
      card.removeEventListener("pointerenter", loadDeferredSecondary);
      card.removeEventListener("focusin", loadDeferredSecondary);
      card.removeEventListener("touchstart", loadDeferredSecondary);
      card.removeEventListener("ff:load-secondary", loadDeferredSecondary);
      delete card.dataset.ffSecondaryInit;
    });
  });
}



  function initFfCollectionDescriptionCollapsibles(root) {
    qsa(root, "[data-collapsible-description]").forEach((wrap) => {
      if (wrap.dataset.collapseReady === "true") return;

      const button = wrap.querySelector("[data-collapsible-description-toggle]");
      const content = wrap.querySelector(".collection-description__inner");
      if (!button || !content) return;

      wrap.dataset.collapseReady = "true";

      const mq = window.matchMedia("(max-width: 999px)");
      let rafId = null;

      const setupMobile = () => {
        wrap.classList.add("is-collapsed");
        wrap.classList.remove("is-expanded");
        button.setAttribute("aria-expanded", "false");

        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
          rafId = null;
          const hasOverflow = content.scrollHeight > content.clientHeight + 4;
          button.hidden = !hasOverflow;

          if (!hasOverflow) {
            wrap.classList.remove("is-collapsed", "is-expanded");
          }
        });
      };

      const setupDesktop = () => {
        if (rafId) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }

        wrap.classList.remove("is-collapsed", "is-expanded");
        button.hidden = true;
        button.setAttribute("aria-expanded", "true");
      };

      const update = () => {
        if (mq.matches) setupMobile();
        else setupDesktop();
      };

      const onClick = () => {
        const expand = !wrap.classList.contains("is-expanded");
        wrap.classList.toggle("is-expanded", expand);
        wrap.classList.toggle("is-collapsed", !expand);
        button.setAttribute("aria-expanded", expand ? "true" : "false");
      };

      const onLoad = () => update();
      const onMqChange = () => update();

      button.addEventListener("click", onClick);
      window.addEventListener("load", onLoad, { once: true });

      if (mq.addEventListener) mq.addEventListener("change", onMqChange);
      else if (mq.addListener) mq.addListener(onMqChange);

      update();

      registerCleanup(wrap, () => {
        if (rafId) cancelAnimationFrame(rafId);
        button.removeEventListener("click", onClick);
        window.removeEventListener("load", onLoad);
        if (mq.removeEventListener) mq.removeEventListener("change", onMqChange);
        else if (mq.removeListener) mq.removeListener(onMqChange);
        delete wrap.dataset.collapseReady;
      });
    });
  }

  function initFfCollectionBanners(root) {
    qsa(root, "[data-ff-collection-banner]").forEach((banner) => {
      if (banner.dataset.ffCollectionBannerInit === "true") return;

      const text = banner.querySelector("[data-ff-collection-banner-text]");
      if (!text) return;

      banner.dataset.ffCollectionBannerInit = "true";

      const mq = window.matchMedia("(min-width: 1000px)");
      let rafId = null;
      let lastApplied = 0;
      let ro = null;
      let detached = false;

      const applySize = () => {
        rafId = null;
        if (detached) return;

        if (!mq.matches) {
          banner.style.removeProperty("--ff-collection-banner-square-size-desktop");
          lastApplied = 0;
          return;
        }

        const next = Math.ceil(text.getBoundingClientRect().height);
        if (!next) return;
        if (Math.abs(next - lastApplied) < 2) return;

        lastApplied = next;
        banner.style.setProperty("--ff-collection-banner-square-size-desktop", `${next}px`);
      };

      const queueApply = () => {
        if (detached) return;
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(applySize);
      };

      if ("ResizeObserver" in window) {
        ro = new ResizeObserver(queueApply);
        ro.observe(text);
      }

      window.addEventListener("resize", queueApply, { passive: true });

      const onMqChange = () => queueApply();
      if (mq.addEventListener) mq.addEventListener("change", onMqChange);
      else if (mq.addListener) mq.addListener(onMqChange);

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          if (!detached) queueApply();
        });
      }

      queueApply();

      registerCleanup(banner, () => {
        detached = true;
        if (rafId) cancelAnimationFrame(rafId);
        if (ro) ro.disconnect();
        window.removeEventListener("resize", queueApply);
        if (mq.removeEventListener) mq.removeEventListener("change", onMqChange);
        else if (mq.removeListener) mq.removeListener(onMqChange);
        banner.style.removeProperty("--ff-collection-banner-square-size-desktop");
        delete banner.dataset.ffCollectionBannerInit;
      });
    });
  }

  function initFfImageTextParallax(root) {
    qsa(root, "[data-ff-parallax-root]").forEach((outer) => {
      if (outer.dataset.ffParallaxInit === "true") return;
      outer.dataset.ffParallaxInit = "true";

      const enabled = outer.getAttribute("data-parallax") === "true";
      const prefersReducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const mobileMQ = window.matchMedia ? window.matchMedia("(max-width: 749px)") : null;
      const isMobile = mobileMQ ? mobileMQ.matches : false;

      if (!enabled || prefersReducedMotion || isMobile) return;

      const sectionEl = outer.querySelector(".ff-parallax__inner");
      const imageContainer = outer.querySelector("[data-parallax-image]");
      if (!sectionEl || !imageContainer) return;

      const speed = parseFloat(outer.getAttribute("data-parallax-speed")) || 0.5;
      let ticking = false;

      const handleScroll = () => {
        const rect = sectionEl.getBoundingClientRect();
        const winH = window.innerHeight || document.documentElement.clientHeight;
        if (rect.bottom <= 0 || rect.top >= winH) return;

        const scrolled = winH - rect.top;
        const total = winH + rect.height;
        const t = scrolled / total;
        const baseFactor = 0.3;
        const maxMove = rect.height * baseFactor;
        const intensity = 1.6;
        const offset = (t - 0.5) * maxMove * 2 * speed * intensity;

        imageContainer.style.transform = `translate3d(0,${offset.toFixed(2)}px,0)`;
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
      };

      const onMobileChange = (event) => {
        if (event.matches) {
          imageContainer.style.removeProperty("transform");
        } else {
          handleScroll();
        }
      };

      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll, { passive: true });

      if (mobileMQ) {
        if (mobileMQ.addEventListener) mobileMQ.addEventListener("change", onMobileChange);
        else if (mobileMQ.addListener) mobileMQ.addListener(onMobileChange);
      }

      handleScroll();

      registerCleanup(outer, () => {
        window.removeEventListener("scroll", onScroll);
        window.removeEventListener("resize", onScroll);
        if (mobileMQ) {
          if (mobileMQ.removeEventListener) mobileMQ.removeEventListener("change", onMobileChange);
          else if (mobileMQ.removeListener) mobileMQ.removeListener(onMobileChange);
        }
        imageContainer.style.removeProperty("transform");
        delete outer.dataset.ffParallaxInit;
      });
    });
  }

  function initFfHeaderSidebarAccordions(root) {
    qsa(root, "[data-ff-header-sidebar-accordions]").forEach((sidebar) => {
      if (sidebar.dataset.ffHeaderSidebarAccordionsInit === "true") return;
      sidebar.dataset.ffHeaderSidebarAccordionsInit = "true";

      const detailsList = Array.from(sidebar.querySelectorAll(".header-sidebar__sub-panel details"));
      if (!detailsList.length) return;

      const onToggle = (event) => {
        const details = event.currentTarget;
        if (!details || !details.open) return;

        details
          .closest(".header-sidebar__sub-panel")
          ?.querySelectorAll("details[open]")
          .forEach((other) => {
            if (other !== details) other.removeAttribute("open");
          });
      };

      detailsList.forEach((details) => details.addEventListener("toggle", onToggle));

      registerCleanup(sidebar, () => {
        detailsList.forEach((details) => details.removeEventListener("toggle", onToggle));
        delete sidebar.dataset.ffHeaderSidebarAccordionsInit;
      });
    });
  }


  function initFfFilterModals(root) {
    qsa(root, "[data-ff-filter-modal]").forEach((component) => {
      if (component.dataset.ffFilterModalInit === "true") return;

      const trigger = component.querySelector("[data-filter-modal-trigger]");
      const dialog = component.querySelector("[data-filter-modal-dialog]");
      const overlay = component.querySelector("[data-filter-modal-overlay]");
      const closeButton = component.querySelector("[data-filter-modal-close]");

      if (!trigger || !dialog || !overlay || !closeButton) return;

      const useBodyPortal = component.hasAttribute("data-ff-filter-modal-portal");
      if (useBodyPortal) {
        document.body.append(overlay, dialog);
      }

      component.dataset.ffFilterModalInit = "true";

      const focusableSelector =
        'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';
      let isOpen = false;
      let previouslyFocusedElement = null;

      const getFocusableElements = () => {
        return Array.from(dialog.querySelectorAll(focusableSelector)).filter(
          (el) => !el.hasAttribute("disabled") && el.getAttribute("tabindex") !== "-1"
        );
      };

      const focusFirstElement = () => {
        const focusables = getFocusableElements();
        if (focusables.length) {
          focusables[0].focus();
        } else {
          closeButton.focus();
        }
      };

      const trapFocus = (event) => {
        const focusables = getFocusableElements();
        if (!focusables.length) return;

        const first = focusables[0];
        const last = focusables[focusables.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      };

      const handleKeydown = (event) => {
        if (event.key === "Escape") {
          close();
          return;
        }

        if (event.key === "Tab") {
          trapFocus(event);
        }
      };

      const open = () => {
        if (isOpen) return;
        isOpen = true;

        previouslyFocusedElement = document.activeElement;

        dialog.classList.add("is-active");
        overlay.classList.add("is-active");
        dialog.setAttribute("aria-hidden", "false");
        trigger.setAttribute("aria-expanded", "true");
        document.documentElement.classList.add("lock");
        document.addEventListener("keydown", handleKeydown);

        focusFirstElement();
      };

      const close = () => {
        if (!isOpen) return;
        isOpen = false;

        dialog.classList.remove("is-active");
        overlay.classList.remove("is-active");
        dialog.setAttribute("aria-hidden", "true");
        trigger.setAttribute("aria-expanded", "false");
        document.documentElement.classList.remove("lock");
        document.removeEventListener("keydown", handleKeydown);

        if (previouslyFocusedElement && typeof previouslyFocusedElement.focus === "function") {
          previouslyFocusedElement.focus();
        } else {
          trigger.focus();
        }
      };

      const onTriggerClick = () => open();
      const onCloseClick = () => close();
      const onOverlayClick = () => close();

      trigger.addEventListener("click", onTriggerClick);
      closeButton.addEventListener("click", onCloseClick);
      overlay.addEventListener("click", onOverlayClick);

      registerCleanup(component, () => {
        trigger.removeEventListener("click", onTriggerClick);
        closeButton.removeEventListener("click", onCloseClick);
        overlay.removeEventListener("click", onOverlayClick);
        document.removeEventListener("keydown", handleKeydown);

        dialog.classList.remove("is-active");
        overlay.classList.remove("is-active");
        dialog.setAttribute("aria-hidden", "true");
        trigger.setAttribute("aria-expanded", "false");
        document.documentElement.classList.remove("lock");

        if (useBodyPortal) {
          overlay.remove();
          dialog.remove();
        }

        delete component.dataset.ffFilterModalInit;
      });
    });
  }
  function initFfInlineActionHelpers(root) {
    qsa(root, "[data-ff-submit-on-change]").forEach((field) => {
      if (field.dataset.ffSubmitOnChangeInit === "true") return;
      field.dataset.ffSubmitOnChangeInit = "true";

      const onChange = () => field.form && field.form.submit && field.form.submit();
      field.addEventListener("change", onChange);

      registerCleanup(field, () => {
        field.removeEventListener("change", onChange);
        delete field.dataset.ffSubmitOnChangeInit;
      });
    });

    qsa(root, "[data-ff-select-on-click]").forEach((field) => {
      if (field.dataset.ffSelectOnClickInit === "true") return;
      field.dataset.ffSelectOnClickInit = "true";

      const onClick = () => typeof field.select === "function" && field.select();
      field.addEventListener("click", onClick);

      registerCleanup(field, () => {
        field.removeEventListener("click", onClick);
        delete field.dataset.ffSelectOnClickInit;
      });
    });

    qsa(root, "[data-ff-print-trigger]").forEach((button) => {
      if (button.dataset.ffPrintTriggerInit === "true") return;
      button.dataset.ffPrintTriggerInit = "true";

      const onClick = () => window.print();
      button.addEventListener("click", onClick);

      registerCleanup(button, () => {
        button.removeEventListener("click", onClick);
        delete button.dataset.ffPrintTriggerInit;
      });
    });

    qsa(root, "[data-ff-row-link]").forEach((row) => {
      if (row.dataset.ffRowLinkInit === "true") return;

      const url = row.getAttribute("data-ff-row-link");
      if (!url) return;

      row.dataset.ffRowLinkInit = "true";

      const isInteractiveTarget = (target) => {
        return !!(target && target.closest && target.closest('a, button, input, select, textarea, summary, [role="button"], [role="link"]'));
      };

      const navigate = () => window.location.assign(url);

      const onClick = (event) => {
        if (isInteractiveTarget(event.target)) return;
        navigate();
      };

      const onKeydown = (event) => {
        if (event.key !== "Enter" && event.key !== " ") return;
        if (isInteractiveTarget(event.target)) return;
        event.preventDefault();
        navigate();
      };

      row.addEventListener("click", onClick);
      row.addEventListener("keydown", onKeydown);

      registerCleanup(row, () => {
        row.removeEventListener("click", onClick);
        row.removeEventListener("keydown", onKeydown);
        delete row.dataset.ffRowLinkInit;
      });
    });
  }

  function initFfPageUtilities(root) {
    if (root && root !== document && root !== document.body && root !== document.documentElement) {
      return;
    }

    const pageType = window.themeVariables && window.themeVariables.settings
      ? window.themeVariables.settings.pageType
      : null;

    if (pageType === "policy") {
      qsa(document, ".shopify-policy__title").forEach((title) => title.classList.add("h2"));
      qsa(document, ".rte").forEach((rte) => rte.classList.add("prose"));
    }

    if (pageType === "") {
      qsa(document, ".shopify-email-marketing-confirmation__container").forEach((container) => {
        container.classList.add("prose");
      });
    }
  }

  /* ============= TABS ============= */

  function initFfTabs(root) {
    qsa(root, "[data-ff-tabs]").forEach(function (group) {
      if (group.dataset.ffTabsInit === "true") return;
      group.dataset.ffTabsInit = "true";
      setupTabs(group);
    });
  }

  function safeQueryById(container, id) {
    if (!id) return null;

    if (window.CSS && typeof CSS.escape === "function") {
      try {
        return container.querySelector("#" + CSS.escape(id));
      } catch (e) {}
    }
    return container.querySelector("#" + id.replace(/"/g, '\\"'));
  }

  function setupTabs(group) {
    var tablist = group.querySelector("[data-ff-tablist]") || group;
    var tabs = tablist.querySelectorAll("[data-ff-tab]");
    var panels = group.querySelectorAll("[data-ff-tab-panel]");
    if (!tabs.length || !panels.length) return;

    var cleanupFns = [];

    tablist.setAttribute("role", "tablist");

    tabs.forEach(function (tab, index) {
      var tabId = tab.id || nextId("ff-tab");
      tab.id = tabId;

      var targetId = tab.getAttribute("data-ff-tab-target");
      var panel = null;

      if (targetId) {
        panel = safeQueryById(group, targetId);
      } else if (panels[index]) {
        panel = panels[index];
        targetId = panel.id || nextId("ff-tab-panel");
      }

      if (panel) {
        panel.id = targetId;
        panel.setAttribute("role", "tabpanel");
        panel.setAttribute("aria-labelledby", tabId);
      }

      tab.setAttribute("role", "tab");
      tab.setAttribute("aria-controls", targetId || "");
      tab.setAttribute("tabindex", index === 0 ? "0" : "-1");
      tab.setAttribute("aria-selected", index === 0 ? "true" : "false");

      if (panel) panel.hidden = index !== 0;

      var onClick = function () {
        activateTab(group, tab);
      };

      var onKeydown = function (event) {
        handleTabKeydown(event, group);
      };

      tab.addEventListener("click", onClick);
      tab.addEventListener("keydown", onKeydown);

      cleanupFns.push(function () {
        tab.removeEventListener("click", onClick);
        tab.removeEventListener("keydown", onKeydown);
      });
    });

    registerCleanup(group, function () {
      cleanupFns.forEach(function (cleanup) {
        try {
          cleanup();
        } catch (_) {}
      });
      delete group.dataset.ffTabsInit;
    });
  }

  function activateTab(group, activeTab) {
    var tabs = group.querySelectorAll("[data-ff-tab]");
    var panels = group.querySelectorAll("[data-ff-tab-panel]");

    tabs.forEach(function (tab) {
      var isActive = tab === activeTab;
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
      tab.setAttribute("tabindex", isActive ? "0" : "-1");
    });

    panels.forEach(function (panel) {
      var labelledBy = panel.getAttribute("aria-labelledby");
      var controllingTab = labelledBy ? group.querySelector("#" + labelledBy) : null;
      panel.hidden = controllingTab !== activeTab;
    });

    activeTab.focus();
  }

  function handleTabKeydown(event, group) {
    var key = event.key;
    if (
      key !== "ArrowLeft" &&
      key !== "ArrowRight" &&
      key !== "ArrowUp" &&
      key !== "ArrowDown" &&
      key !== "Home" &&
      key !== "End"
    ) {
      return;
    }

    var tabs = Array.prototype.slice.call(group.querySelectorAll("[data-ff-tab]"));
    var currentIndex = tabs.indexOf(document.activeElement);
    if (currentIndex === -1) return;

    event.preventDefault();

    var nextIndex = currentIndex;
    if (key === "ArrowLeft" || key === "ArrowUp") {
      nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    } else if (key === "ArrowRight" || key === "ArrowDown") {
      nextIndex = (currentIndex + 1) % tabs.length;
    } else if (key === "Home") {
      nextIndex = 0;
    } else if (key === "End") {
      nextIndex = tabs.length - 1;
    }

    var nextTab = tabs[nextIndex];
    if (nextTab) activateTab(group, nextTab);
  }

  /* ========== ACCORDIONS ========== */

  function initFfAccordions(root) {
    qsa(root, "[data-ff-accordion]").forEach(function (accordion) {
      if (accordion.dataset.ffAccordionInit === "true") return;
      accordion.dataset.ffAccordionInit = "true";
      setupAccordion(accordion);
    });
  }

  function setupAccordion(accordion) {
    var items = accordion.querySelectorAll("[data-ff-accordion-item]");
    if (!items.length) return;

    var cleanupFns = [];

    items.forEach(function (item) {
      var button = item.querySelector("[data-ff-accordion-button]");
      var panel = item.querySelector("[data-ff-accordion-panel]");
      if (!button || !panel) return;

      var btnId = button.id || nextId("ff-acc-btn");
      var panelId = panel.id || nextId("ff-acc-panel");
      button.id = btnId;
      panel.id = panelId;

      if (!button.getAttribute("type")) button.setAttribute("type", "button");

      button.setAttribute("aria-controls", panelId);

      var isOpen = !panel.hasAttribute("hidden");
      button.setAttribute("aria-expanded", isOpen ? "true" : "false");

      panel.setAttribute("role", "region");
      panel.setAttribute("aria-labelledby", btnId);
      panel.hidden = !isOpen;

      function handleToggle(ev) {
        if (ev.type === "keydown" && ev.key !== "Enter" && ev.key !== " ") return;
        ev.preventDefault();
        toggleAccordion(accordion, button, panel);
      }

      button.addEventListener("click", handleToggle);
      button.addEventListener("keydown", handleToggle);

      cleanupFns.push(function () {
        button.removeEventListener("click", handleToggle);
        button.removeEventListener("keydown", handleToggle);
      });
    });

    registerCleanup(accordion, function () {
      cleanupFns.forEach(function (cleanup) {
        try {
          cleanup();
        } catch (_) {}
      });
      delete accordion.dataset.ffAccordionInit;
    });
  }

  function toggleAccordion(accordion, button, panel) {
    var single = accordion.dataset.ffAccordionSingle === "true";
    var isOpen = button.getAttribute("aria-expanded") === "true";

    if (single) {
      accordion.querySelectorAll("[data-ff-accordion-button]").forEach(function (btn) {
        btn.setAttribute("aria-expanded", "false");
      });
      accordion.querySelectorAll("[data-ff-accordion-panel]").forEach(function (p) {
        p.hidden = true;
      });
    }

    button.setAttribute("aria-expanded", isOpen ? "false" : "true");
    panel.hidden = isOpen;
  }

  /* ========== HEADER ENHANCEMENTS (FF) ========== */

  function initFfHeader(root) {
    qsa(root, "[data-ff-header]").forEach((header) => {
      if (header.dataset.ffHeaderInit === "true") return;
      header.dataset.ffHeaderInit = "true";
      setupFfHeader(header);
    });
  }

  function closeDisclosure(detailsEl) {
    const wrapper = detailsEl.closest("mega-menu-disclosure, dropdown-menu-disclosure");
    if (wrapper && typeof wrapper.toggle === "function") {
      wrapper.toggle(false);
      return;
    }
    detailsEl.open = false;
    detailsEl.removeAttribute("open");
  }

  function setupFfHeader(header) {
    const disclosures = header.querySelectorAll("details[data-ff-menu-disclosure]");
    const cleanupFns = [];

    disclosures.forEach((d) => {
      const summary = d.querySelector(":scope > summary");

      const sync = () => {
        const panel = d.querySelector(".mega-menu, .header__dropdown-menu");
        if (!panel) return;

        const isOpen = !!d.open;

        panel.toggleAttribute("inert", !isOpen);
        panel.setAttribute("aria-hidden", isOpen ? "false" : "true");

        if (summary) summary.setAttribute("aria-expanded", isOpen ? "true" : "false");

        if (isOpen && summary && document.activeElement === summary) {
          const first = panel.querySelector('a,button,[tabindex]:not([tabindex="-1"])');
          if (first) first.focus({ preventScroll: true });
        }
      };

      sync();
      d.addEventListener("toggle", sync);
      cleanupFns.push(() => d.removeEventListener("toggle", sync));

      const onKeydown = (e) => {
        if (e.key !== "Escape") return;
        if (!d.open) return;
        e.preventDefault();
        closeDisclosure(d);
        summary && summary.focus({ preventScroll: true });
      };

      d.addEventListener("keydown", onKeydown);
      cleanupFns.push(() => d.removeEventListener("keydown", onKeydown));
    });

    header.querySelectorAll('details[data-ff-menu-disclosure] > summary').forEach((s) => {
      let done = false;
      const warm = () => {
        if (done) return;
        done = true;

        const d = s.parentElement;
        const panel = d && d.querySelector(".mega-menu, .header__dropdown-menu");
        if (!panel) return;

        panel.querySelectorAll('img[loading="lazy"]').forEach((img) => {
          img.removeAttribute("loading");
          try {
            img.decoding = "async";
            if ("fetchPriority" in img) img.fetchPriority = "low";
          } catch (_) {}
        });
      };

      s.addEventListener("pointerenter", warm, { once: true, passive: true });
      s.addEventListener("focus", warm, { once: true });
      s.addEventListener("touchstart", warm, { once: true, passive: true });

      cleanupFns.push(() => {
        s.removeEventListener("pointerenter", warm);
        s.removeEventListener("focus", warm);
        s.removeEventListener("touchstart", warm);
      });
    });

    registerCleanup(header, () => {
      cleanupFns.forEach((cleanup) => {
        try {
          cleanup();
        } catch (_) {}
      });
      delete header.dataset.ffHeaderInit;
    });
  }

  /* ========== ANNOUNCEMENT BAR (FF) ========== */

  function initFfAnnouncementBars(root) {
    qsa(root, "[data-ff-announce]").forEach((bar) => {
      if (bar.dataset.ffAnnounceInit === "true") return;
      bar.dataset.ffAnnounceInit = "true";
      setupFfAnnouncementBar(bar);
    });
  }

  /* ===== Set 3: independent announcement-bar height ownership ===== */
  let ffAnnouncementHeightFrame = null;

  function syncFfAnnouncementHeight() {
    if (ffAnnouncementHeightFrame !== null) return;
    ffAnnouncementHeightFrame = requestAnimationFrame(() => {
      ffAnnouncementHeightFrame = null;
      updateFfAnnouncementHeight();
    });
  }

  function updateFfAnnouncementHeight() {
    const header = document.querySelector('.shopify-section--ff-header');
    if (!header) return;
    let height = 0;
    document.querySelectorAll('.shopify-section--announcement-bar').forEach((section) => {
      const bar = section.querySelector('[data-ff-announce]');
      if (!bar || !section.isConnected || bar.getAttribute('data-hidden') === 'true') return;
      // Bars below the header must never replace its preceding-bar offset.
      if (!(section.compareDocumentPosition(header) & Node.DOCUMENT_POSITION_FOLLOWING)) return;
      if (getComputedStyle(section).display === 'none' || getComputedStyle(bar).display === 'none') return;
      height += section.getBoundingClientRect().height;
    });
    const style = document.documentElement.style;
    const value = `${height.toFixed(2)}px`;
    if (style.getPropertyValue('--announcement-bar-height') !== value) {
      style.setProperty('--announcement-bar-height', value);
    }
  }

  function setupFfAnnouncementBar(root) {
    const designMode = !!(window.Shopify && window.Shopify.designMode);
    const storageBase = root.getAttribute('data-announcement-storage-key') || root.id || nextId('ff-announce');
    const storageKey = `ff-announce-${storageBase}-closed`;
    const pauseKey = `ff-announce-${storageBase}-paused`;
    const sessionGet = (key) => {
      try { return window.sessionStorage.getItem(key); } catch (_) { return null; }
    };
    const sessionSet = (key, value) => {
      try { window.sessionStorage.setItem(key, value); } catch (_) {}
    };
    const list = root.querySelector('.ff-announce__messages');
    if (!list) {
      delete root.dataset.ffAnnounceInit;
      return;
    }
    if (!designMode && sessionGet(storageKey) === 'true') {
      root.setAttribute('data-hidden', 'true');
      syncFfAnnouncementHeight();
      registerCleanup(root, () => {
        delete root.dataset.ffAnnounceInit;
        syncFfAnnouncementHeight();
      });
      return;
    }

    const closeButton = root.querySelector('.ff-announce__close');
    const rotationButton = root.querySelector('.ff-announce__rotation-toggle');
    const previousButton = root.querySelector('.ff-announce__previous');
    const nextButton = root.querySelector('.ff-announce__next');
    const positionTemplate = list.dataset.ffPositionTemplate || '%index% of %count%';
    const rotationSymbol = rotationButton && rotationButton.querySelector('.ff-announce__rotation-symbol');
    const pauseLabel = rotationButton?.dataset.ffPauseLabel || 'Pause announcements';
    const resumeLabel = rotationButton?.dataset.ffResumeLabel || 'Resume announcements';
    const waitingLabel = rotationButton?.dataset.ffWaitingLabel || 'Pause announcements (rotation resumes after leaving this bar)';
    const nextLabel = rotationButton?.dataset.ffNextLabel || 'Next announcement';
    const allItems = Array.from(list.querySelectorAll('.ff-announce__message'));
    const country = (root.getAttribute('data-country') || 'EU').toUpperCase();
    const eu = ['DE','FR','IT','ES','NL','BE','AT','PL','SE','DK','FI','IE','PT','GR','CZ','RO','HU','LU','EE','LV','LT','SI','SK','HR','BG','CY','MT'];
    const isEligible = (region) => {
      if (region === 'all') return true;
      if (region === 'uk') return country === 'GB' || country === 'UK';
      if (region === 'ch') return country === 'CH';
      return eu.includes(country);
    };
    const items = allItems.filter((item) => {
      const eligible = item.getAttribute('data-ff-editor-placeholder') !== 'true' &&
        isEligible((item.getAttribute('data-region') || 'all').toLowerCase());
      item.setAttribute('data-visible', eligible ? 'true' : 'false');
      return eligible;
    });
    const positionLabel = (position) => positionTemplate
      .replace('%index%', String(position)).replace('%count%', String(items.length));
    items.forEach((item, itemIndex) => {
      item.setAttribute('aria-label', positionLabel(itemIndex + 1));
    });

    const ac = 'AbortController' in window ? new AbortController() : null;
    const cleanups = [];
    const on = (node, event, listener, passive = false) => {
      if (!node) return;
      const opts = ac ? { signal: ac.signal, passive } : { passive };
      node.addEventListener(event, listener, opts);
      if (!ac) cleanups.push(() => node.removeEventListener(event, listener, opts));
    };
    const mq = window.matchMedia('(max-width:749px)');
    const reducedMq = window.matchMedia('(prefers-reduced-motion: reduce)');
    let isMobile = mq.matches;
    let editorSelectedMessage = null;
    let manuallyPaused = !designMode && sessionGet(pauseKey) === 'true';
    // Once keyboard focus enters the bar, require an explicit Resume action.
    // Hover pauses remain temporary; pointer-induced focus does not lock rotation.
    let keyboardPaused = false;
    let lastPointerFocusAt = 0;
    let pointerInside = false;
    let timer = null;
    let index = 0;
    let startX = 0;
    const initialTabindexes = new WeakMap();
    const mobileSeconds = parseInt(root.dataset.mobileRotationInterval, 10) || 8;
    const desktopSeconds = parseInt(root.dataset.desktopRotationInterval, 10) || mobileSeconds;

    function stop() {
      if (!timer) return;
      clearInterval(timer);
      timer = null;
    }
    function updateRotationControl() {
      if (!rotationButton) return;
      const show = items.length > 1;
      rotationButton.hidden = !show || reducedMq.matches;
      if (previousButton) previousButton.hidden = !show;
      if (nextButton) nextButton.hidden = !show;
      root.classList.toggle('ff-announce--rotatable', show);
      root.classList.toggle('ff-announce--manual-only', show && reducedMq.matches);
      if (!show) return;
      const paused = manuallyPaused || keyboardPaused;
      // After an explicit Resume, focus/hover may still delay rotation until
      // the user leaves the bar. This is distinct from the keyboard focus stop.
      const waiting = !paused && !reducedMq.matches &&
        (root.contains(document.activeElement) || pointerInside);
      const label = reducedMq.matches ? nextLabel :
        paused ? resumeLabel : waiting ? waitingLabel : pauseLabel;
      rotationButton.setAttribute('aria-label', label);
      rotationButton.title = label;
      rotationButton.dataset.ffRotationState = reducedMq.matches ? 'manual' :
        paused ? 'paused' : waiting ? 'waiting' : 'playing';
      if (rotationSymbol) rotationSymbol.textContent = reducedMq.matches ? '›' : (paused ? '▶' : 'Ⅱ');
    }
    function canRotate() {
      return !manuallyPaused && !keyboardPaused && !reducedMq.matches && !editorSelectedMessage && items.length > 1 &&
        root.getAttribute('data-hidden') !== 'true' && !root.contains(document.activeElement) &&
        !pointerInside && !document.hidden;
    }
    function syncRotation() {
      stop();
      const rotating = canRotate();
      list.setAttribute('aria-live', rotating ? 'off' : 'polite');
      if (rotating) {
        const seconds = isMobile ? mobileSeconds : desktopSeconds;
        timer = setInterval(next, Math.max(seconds, 2) * 1000);
      }
      // Rotation state must also update on blur, hover-out and visibility changes.
      updateRotationControl();
    }
    function setActive(nextIndex) {
      const activeItem = editorSelectedMessage || items[nextIndex] || null;
      allItems.forEach((item) => {
        const active = item === activeItem;
        const visible = items.includes(item) || (designMode && item === editorSelectedMessage);
        item.setAttribute('data-visible', visible ? 'true' : 'false');
        item.setAttribute('data-active', active ? 'true' : 'false');
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
        item.querySelectorAll('a[href], button, input, select, textarea, [tabindex]').forEach((element) => {
          if (!initialTabindexes.has(element)) {
            initialTabindexes.set(element, element.hasAttribute('tabindex') ? element.getAttribute('tabindex') : null);
          }
          const original = initialTabindexes.get(element);
          if (active) {
            if (original === null) element.removeAttribute('tabindex');
            else element.setAttribute('tabindex', original);
          } else {
            element.setAttribute('tabindex', '-1');
          }
        });
      });
      syncFfAnnouncementHeight();
    }
    function next() {
      if (items.length < 2) return;
      index = (index + 1) % items.length;
      setActive(index);
    }
    function prev() {
      if (items.length < 2) return;
      index = (index - 1 + items.length) % items.length;
      setActive(index);
    }
    function navigateManually(delta) {
      if (items.length < 2) return;
      // Manual browsing must remain available while paused and must not
      // restart automatic rotation. The next explicit Resume can do that.
      manuallyPaused = true;
      if (!designMode) sessionSet(pauseKey, 'true');
      syncRotation();
      if (delta > 0) next();
      else prev();
    }
    function onTouchStart(event) {
      if (!isMobile || !event.changedTouches.length) return;
      startX = event.changedTouches[0].screenX;
      stop();
    }
    function onTouchEnd(event) {
      if (!isMobile || !event.changedTouches.length) return;
      const delta = startX - event.changedTouches[0].screenX;
      if (Math.abs(delta) > 50) navigateManually(delta > 0 ? 1 : -1);
      else syncRotation();
    }
    function eventMessage(event) {
      return event.target?.closest?.('.ff-announce__message') || null;
    }

    if (!items.length && !designMode) root.setAttribute('data-hidden', 'true');
    setActive(index);
    updateRotationControl();
    syncFfAnnouncementHeight();

    if (previousButton) on(previousButton, 'click', () => navigateManually(-1));
    if (nextButton) on(nextButton, 'click', () => navigateManually(1));
    if (rotationButton) {
      on(rotationButton, 'click', () => {
        if (reducedMq.matches) { navigateManually(1); return; }
        if (manuallyPaused || keyboardPaused) {
          // Only the rotation control can restart after keyboard focus entered.
          manuallyPaused = false;
          keyboardPaused = false;
        } else {
          manuallyPaused = true;
        }
        if (!designMode) sessionSet(pauseKey, manuallyPaused ? 'true' : 'false');
        syncRotation();
      });
    }
    if (closeButton) {
      on(closeButton, 'click', () => {
        if (!designMode) sessionSet(storageKey, 'true');
        root.setAttribute('data-hidden', 'true');
        stop();
        syncFfAnnouncementHeight();
        // A focused button must not disappear without providing the next location.
        if (root.contains(document.activeElement)) {
          document.querySelector('[data-ff-header] a[href], [data-ff-header] button')?.focus({ preventScroll: true });
        }
      });
    }
    on(root, 'mouseenter', () => { pointerInside = true; syncRotation(); });
    on(root, 'mouseleave', () => { pointerInside = false; syncRotation(); });
    // A pointer click can move focus as part of its default action. Distinguish
    // that from keyboard focus so mouse hover does not become a permanent stop.
    // On touchscreens focus may arrive after pointerup. Keep the pointer
    // origin briefly, but let any subsequent keyboard action take precedence.
    on(root, 'pointerdown', () => { lastPointerFocusAt = Date.now(); });
    on(root, 'pointercancel', () => { lastPointerFocusAt = 0; });
    on(document, 'keydown', () => { lastPointerFocusAt = 0; });
    on(root, 'focusin', (event) => {
      const fromPointer = Date.now() - lastPointerFocusAt < 1500;
      if (!root.contains(event.relatedTarget) && !fromPointer) keyboardPaused = true;
      lastPointerFocusAt = 0;
      syncRotation();
    });
    on(root, 'focusout', (event) => {
      if (!root.contains(event.relatedTarget)) syncRotation();
    });
    on(list, 'touchstart', onTouchStart, true);
    on(list, 'touchend', onTouchEnd, true);
    on(window, 'resize', syncFfAnnouncementHeight, true);
    on(document, 'visibilitychange', syncRotation);
    const onMqChange = (event) => {
      isMobile = event.matches;
      syncRotation();
      syncFfAnnouncementHeight();
    };
    const onReducedChange = () => {
      // The playback control disappears under reduced motion. Move focus to
      // manual navigation first so keyboard users stay inside the carousel.
      const focusWasOnPlayback = reducedMq.matches &&
        rotationButton && document.activeElement === rotationButton;
      updateRotationControl();
      if (focusWasOnPlayback) {
        const nextFocus = [nextButton, previousButton, closeButton].find(
          (button) => button && !button.hidden && !button.disabled
        );
        nextFocus?.focus({ preventScroll: true });
      }
      syncRotation();
      syncFfAnnouncementHeight();
    };
    if (mq.addEventListener) mq.addEventListener('change', onMqChange);
    else if (mq.addListener) mq.addListener(onMqChange);
    if (reducedMq.addEventListener) reducedMq.addEventListener('change', onReducedChange);
    else if (reducedMq.addListener) reducedMq.addListener(onReducedChange);

    if (designMode) {
      on(document, 'shopify:block:select', (event) => {
        const message = eventMessage(event);
        if (!message || !root.contains(message)) return;
        editorSelectedMessage = message;
        root.removeAttribute('data-hidden');
        const chosen = items.indexOf(message);
        if (chosen >= 0) index = chosen;
        setActive(index);
        syncRotation();
      });
      on(document, 'shopify:block:deselect', (event) => {
        if (eventMessage(event) !== editorSelectedMessage || !editorSelectedMessage) return;
        editorSelectedMessage = null;
        setActive(index);
        syncRotation();
      });
      on(document, 'shopify:section:select', (event) => {
        if (event.target && event.target.contains(root)) {
          root.removeAttribute('data-hidden');
          setActive(index);
          syncRotation();
        }
      });
    }
    const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(syncFfAnnouncementHeight) : null;
    if (resizeObserver) resizeObserver.observe(root);
    syncRotation();
    registerCleanup(root, () => {
      stop();
      if (ac) ac.abort();
      cleanups.forEach((cleanup) => cleanup());
      if (resizeObserver) resizeObserver.disconnect();
      if (mq.removeEventListener) mq.removeEventListener('change', onMqChange);
      else if (mq.removeListener) mq.removeListener(onMqChange);
      if (reducedMq.removeEventListener) reducedMq.removeEventListener('change', onReducedChange);
      else if (reducedMq.removeListener) reducedMq.removeListener(onReducedChange);
      delete root.dataset.ffAnnounceInit;
      syncFfAnnouncementHeight();
    });
  }


  function initFfMainProduct(root) {
    qsa(root, "[data-ff-main-product]").forEach((section) => {
      if (section.dataset.ffMainProductInit === "1") return;
      section.dataset.ffMainProductInit = "1";

      const productId = section.dataset.ffProductId;
      if (!productId) return;

      try {
        let recentlyViewedProducts = JSON.parse(localStorage.getItem("theme:recently-viewed-products") || "[]");
        recentlyViewedProducts = recentlyViewedProducts.filter((item) => String(item) !== String(productId));
        recentlyViewedProducts.unshift(Number(productId));
        localStorage.setItem("theme:recently-viewed-products", JSON.stringify(recentlyViewedProducts));
      } catch (_) {}

      const tailBlockTypes = ["ff-blog-teaser", "image", "modal"];
const tailSelector = [
  ...tailBlockTypes.map((type) => `.product-info__block-item[data-block-type="${type}"]`),
  `.product-info__block-item[data-ff-mobile-below-gallery="true"]`
].join(",");
      const mqDesktop = window.matchMedia("(min-width: 1000px)");
      let rafId = 0;
      let mutationObserver = null;
      let removeMqListener = null;

      function ensureTrackedTailItems() {
        if (!tailSelector) return;

        qsa(section, tailSelector).forEach((item) => {
          if (item.dataset.ffMobileTailId) return;
          if (!item.parentNode) return;

          const tailId = nextId("ff-mobile-tail");
          const placeholder = document.createElement("div");

          placeholder.hidden = true;
          placeholder.setAttribute("data-ff-mobile-tail-placeholder", tailId);
          item.dataset.ffMobileTailId = tailId;

          item.parentNode.insertBefore(placeholder, item);
        });
      }

      function getTailPlaceholderMap() {
        return Array.from(section.querySelectorAll("[data-ff-mobile-tail-placeholder]")).map((placeholder) => {
          const tailId = placeholder.getAttribute("data-ff-mobile-tail-placeholder");
          const item = tailId
            ? section.querySelector(`.product-info__block-item[data-ff-mobile-tail-id="${tailId}"]`)
            : null;

          return { placeholder, item };
        });
      }

      function pruneOrphanPlaceholders() {
        getTailPlaceholderMap().forEach(({ placeholder, item }) => {
          if (!item && placeholder.parentNode) placeholder.parentNode.removeChild(placeholder);
        });
      }

      function restoreDesktopTailItems() {
        getTailPlaceholderMap().forEach(({ placeholder, item }) => {
          if (!placeholder || !item || !placeholder.parentNode) return;

          if (item.parentNode !== placeholder.parentNode || placeholder.nextSibling !== item) {
            placeholder.parentNode.insertBefore(item, placeholder.nextSibling);
          }
        });
      }

      function moveTailItemsBelowGalleryOnMobile() {
  const belowGallery = section.querySelector("#product-extra-information");
  if (!belowGallery) return;

  getTailPlaceholderMap().forEach(({ item }) => {
    if (!item) return;

    const targetId = item.getAttribute("data-ff-mobile-below-gallery-target-id");
    let target = null;

    if (targetId) {
      try {
        target = section.querySelector(
          `[data-ff-mobile-below-gallery-target="${CSS.escape(targetId)}"]`
        );
      } catch (_) {
        target = section.querySelector(
          `[data-ff-mobile-below-gallery-target="${targetId.replace(/"/g, '\\"')}"]`
        );
      }
    }

    if (target && target.parentNode) {
      if (target.nextSibling !== item) {
        target.parentNode.insertBefore(item, target.nextSibling);
      }
      return;
    }

    if (item.parentNode !== belowGallery) {
      belowGallery.appendChild(item);
    }
  });
}

      function applyMobileTailLayout() {
        ensureTrackedTailItems();
        pruneOrphanPlaceholders();

        if (mqDesktop.matches) restoreDesktopTailItems();
        else moveTailItemsBelowGalleryOnMobile();
      }

      function scheduleMobileTailLayout() {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
          rafId = 0;
          applyMobileTailLayout();
        });
      }

      scheduleMobileTailLayout();

      const onMqChange = () => scheduleMobileTailLayout();

      if (mqDesktop.addEventListener) {
        mqDesktop.addEventListener("change", onMqChange);
        removeMqListener = () => mqDesktop.removeEventListener("change", onMqChange);
      } else if (mqDesktop.addListener) {
        mqDesktop.addListener(onMqChange);
        removeMqListener = () => mqDesktop.removeListener(onMqChange);
      }

      if ("MutationObserver" in window) {
        mutationObserver = new MutationObserver(scheduleMobileTailLayout);
        mutationObserver.observe(section, { childList: true, subtree: true });
      }

      registerCleanup(section, () => {
        if (rafId) cancelAnimationFrame(rafId);
        if (mutationObserver) mutationObserver.disconnect();
        if (removeMqListener) removeMqListener();
        restoreDesktopTailItems();

        getTailPlaceholderMap().forEach(({ placeholder, item }) => {
          if (item) item.removeAttribute("data-ff-mobile-tail-id");
          if (placeholder && placeholder.parentNode) {
            placeholder.parentNode.removeChild(placeholder);
          }
        });

        delete section.dataset.ffMainProductInit;
      });
    });
  }


  /* ========== BACK TO TOP (FF) ========== */

  function initFfBackToTop(root) {
    qsa(root, "[data-ff-backtotop]").forEach((btn) => {
      if (btn.dataset.ffBacktotopInit === "true") return;
      btn.dataset.ffBacktotopInit = "true";

      const mq =
        "matchMedia" in window
          ? window.matchMedia("(prefers-reduced-motion: reduce)")
          : null;

      const setHidden = (hidden) => {
        btn.classList.toggle("show", !hidden);
        btn.setAttribute("aria-hidden", hidden ? "true" : "false");
        if (hidden) btn.setAttribute("tabindex", "-1");
        else btn.removeAttribute("tabindex");
      };

      if (!document.body) return;

      let sentinel = document.getElementById("ff-top-sentinel");
      if (!sentinel) {
        sentinel = document.createElement("div");
        sentinel.id = "ff-top-sentinel";
        sentinel.setAttribute("aria-hidden", "true");
        sentinel.style.cssText =
          "position:absolute;top:0;left:0;width:1px;height:1px;pointer-events:none;";
        document.body.insertBefore(sentinel, document.body.firstChild);
      }

      const ac = "AbortController" in window ? new AbortController() : null;
      const listenerOptions = ac ? { signal: ac.signal } : undefined;
      const passiveListenerOptions = ac ? { passive: true, signal: ac.signal } : { passive: true };
      let io = null;
      let onScroll = null;

      setHidden(true);

      if ("IntersectionObserver" in window) {
        io = new IntersectionObserver((entries) => {
          setHidden(entries[0].isIntersecting);
        });
        io.observe(sentinel);
      } else {
        let ticking = false;
        onScroll = () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            setHidden(window.scrollY <= 400);
            ticking = false;
          });
        };
        window.addEventListener("scroll", onScroll, passiveListenerOptions);
        onScroll();
      }

      const onClick = () => {
        if (mq && mq.matches) {
          window.scrollTo(0, 0);
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      };

      btn.addEventListener("click", onClick, listenerOptions);

      registerCleanup(btn, () => {
        if (io) io.disconnect();
        if (!ac && onScroll) window.removeEventListener("scroll", onScroll);
        if (!ac) btn.removeEventListener("click", onClick);
        if (ac) ac.abort();
        setHidden(true);
        delete btn.dataset.ffBacktotopInit;
      });
    });
  }

  /* ========== LIGHT PARALLAX TABLE WRAP (FF) ========== */

  function initFfLightParallax(root) {
    qsa(root, "[data-ff-light-parallax]").forEach((section) => {
      if (section.dataset.ffLightParallaxInit === "true") return;
      section.dataset.ffLightParallaxInit = "true";

      const wrappers = [];

      section.querySelectorAll("table.ff-table-shipping").forEach((table) => {
        const parent = table.parentElement;
        if (parent && parent.classList && parent.classList.contains("ff-table-scroll")) return;

        const wrapper = document.createElement("div");
        wrapper.className = "ff-table-scroll";

        const tableParent = table.parentNode;
        if (!tableParent) return;

        tableParent.insertBefore(wrapper, table);
        wrapper.appendChild(table);
        wrappers.push(wrapper);
      });

      registerCleanup(section, () => {
        wrappers.forEach((wrapper) => {
          const parent = wrapper.parentNode;
          if (!parent) return;

          while (wrapper.firstChild) {
            parent.insertBefore(wrapper.firstChild, wrapper);
          }

          parent.removeChild(wrapper);
        });

        delete section.dataset.ffLightParallaxInit;
      });
    });
  }

  /* ========== QUICK ACCESS (FF) ========== */

  function initFfNewsletterPopupSuccess(root) {
    qsa(root, "[data-ff-newsletter-popup-success]").forEach((marker) => {
      if (marker.dataset.ffNewsletterPopupSuccessInit === "1") return;
      marker.dataset.ffNewsletterPopupSuccessInit = "1";

      try {
        localStorage.setItem("theme:popup-filled", "true");
      } catch (_) {}
    });
  }

  function initFfQuickAccess(root) {
    qsa(root, "[data-ff-quick-access]").forEach((nav) => {
      if (nav.dataset.ffQuickAccessInit === "true") return;
      nav.dataset.ffQuickAccessInit = "true";
      setupFfQuickAccess(nav);
    });
  }

  function setupFfQuickAccess(root) {
    const bar = root.querySelector(".bar");
    const links = Array.prototype.slice.call(root.querySelectorAll("[data-ffqa-link]"));
    if (!bar || !links.length) return;

    const ac = "AbortController" in window ? new AbortController() : null;
    const listenerOptions = ac ? { signal: ac.signal } : undefined;
    const passiveListenerOptions = ac ? { passive: true, signal: ac.signal } : { passive: true };

    let spacer = root.nextElementSibling;
    if (!spacer || !spacer.classList.contains("ffqa-spacer")) spacer = null;

    const targets = [];
    let io = null;
    let resizeObserver = null;
    let mutationObserver = null;
    let rafId = 0;

    function getFooterGroup() {
      return (
        document.querySelector(".shopify-section-group-footer-group") ||
        document.getElementById("ff-footer") ||
        document.querySelector("footer")
      );
    }

    function resolveTarget(rawId) {
      if (!rawId) return null;

      let el = document.getElementById(rawId);
      if (el) return el;

      const isShopifyPref = rawId.indexOf("shopify-section-") === 0;
      const key = isShopifyPref ? rawId.replace(/^shopify-section-/, "") : rawId;
      const wrappers = document.querySelectorAll('[id^="shopify-section-"]');

      for (let i = 0; i < wrappers.length; i += 1) {
        const cid = wrappers[i].id;
        if (cid === rawId) return wrappers[i];
        if (cid.slice(-(key.length + 2)) === "__" + key) return wrappers[i];
        if (!isShopifyPref && cid.slice(-(rawId.length + 2)) === "__" + rawId) return wrappers[i];
      }

      return null;
    }

    links.forEach((link) => {
      const id = link.getAttribute("data-ffqa-link");
      if (!id) return;

      const target = resolveTarget(id);
      if (!target) return;

      target.setAttribute("data-ffqa-target", "");
      targets.push(target);

      if (target.id && link.getAttribute("href") !== "#" + target.id) {
        link.setAttribute("href", "#" + target.id);
      }
    });

    function setOffset() {
      const selectors = [
        ".shopify-section--announcement-bar",
        ".shopify-section--announcement-bar .announcement-bar",
        ".shopify-section--header",
        ".shopify-section--header .header"
      ];

      let maxBottom = 0;

      for (let i = 0; i < selectors.length; i += 1) {
        const el = document.querySelector(selectors[i]);
        if (!el) continue;

        const cs = getComputedStyle(el);
        if (cs.display === "none" || cs.visibility === "hidden" || cs.opacity === "0") continue;

        const rect = el.getBoundingClientRect();
        if (rect.bottom > maxBottom) maxBottom = rect.bottom;
      }

      if (maxBottom <= 0) {
        const fallback = parseFloat(getComputedStyle(root).getPropertyValue("--qa-offset")) || 0;
        maxBottom = fallback;
      }

      const rounded = Math.round(maxBottom);
      root.style.setProperty("--qa-offset-dyn", rounded + "px");

      if (targets.length) {
        const offsetWithGap = rounded + 12;
        targets.forEach((target) => {
          target.style.scrollMarginTop = offsetWithGap + "px";
        });
      }
    }

    function setBarHeight() {
      if (!spacer) return;

      const isSidebarDesktop =
        window.matchMedia("(min-width:1000px)").matches &&
        root.getAttribute("data-desktop-position") === "sidebar";

      if (isSidebarDesktop) {
        spacer.style.height = "0px";
        return;
      }

      const height = bar.getBoundingClientRect().height || 0;
      spacer.style.height = height + "px";
    }

    function clampToFooter() {
      const footerGroup = getFooterGroup();
      if (!footerGroup) return;

      const rect = footerGroup.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      root.classList.toggle("ffqa--hide-footer", rect.top <= vh);
    }

    function scheduleUpdate() {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        rafId = 0;
        setOffset();
        setBarHeight();
        clampToFooter();
      });
    }

    function setActiveLink(activeId) {
      links.forEach((link) => {
        const isActive = Boolean(activeId) && link.getAttribute("href") === "#" + activeId;
        link.classList.toggle("is-active", isActive);

        if (isActive) {
          link.setAttribute("aria-current", "location");
        } else {
          link.removeAttribute("aria-current");
        }
      });
    }

    function bindIO() {
      if (!("IntersectionObserver" in window) || !targets.length) return;

      io = new IntersectionObserver((entries) => {
        const visibleEntries = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => Math.abs(a.boundingClientRect.top - window.innerHeight * 0.45) - Math.abs(b.boundingClientRect.top - window.innerHeight * 0.45));

        if (visibleEntries.length) {
          setActiveLink(visibleEntries[0].target.id);
        }
      }, {
        rootMargin: "-45% 0px -50% 0px",
        threshold: 0.01
      });

      targets.forEach((target) => io.observe(target));
    }

    function jumpToHash() {
      if (location.hash.length <= 1) return;

      const raw = location.hash.slice(1);
      const target = resolveTarget(raw);
      if (!target) return;

      setTimeout(() => {
        const reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        target.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
        setActiveLink(target.id);
      }, 30);
    }

    scheduleUpdate();
    bindIO();
    jumpToHash();

    const onHashChange = () => {
      jumpToHash();
      scheduleUpdate();
    };

    window.addEventListener("hashchange", onHashChange, listenerOptions);
    window.addEventListener("resize", scheduleUpdate, passiveListenerOptions);
    window.addEventListener("scroll", scheduleUpdate, passiveListenerOptions);

    const observedChrome = [
      document.querySelector(".shopify-section--header"),
      document.querySelector(".shopify-section--announcement-bar")
    ].filter(Boolean);

    if ("ResizeObserver" in window && observedChrome.length) {
      resizeObserver = new ResizeObserver(scheduleUpdate);
      observedChrome.forEach((target) => resizeObserver.observe(target));
    } else if ("MutationObserver" in window && observedChrome.length) {
      mutationObserver = new MutationObserver(scheduleUpdate);
      observedChrome.forEach((target) => {
        mutationObserver.observe(target, { attributes: true, attributeFilter: ["class", "style"] });
      });
    }

    registerCleanup(root, () => {
      if (rafId) cancelAnimationFrame(rafId);
      if (io) io.disconnect();
      if (resizeObserver) resizeObserver.disconnect();
      if (mutationObserver) mutationObserver.disconnect();
      if (ac) ac.abort();
      root.style.removeProperty("--qa-offset-dyn");
      root.classList.remove("ffqa--hide-footer");
      if (spacer) spacer.style.removeProperty("height");
      targets.forEach((target) => {
        target.removeAttribute("data-ffqa-target");
        target.style.removeProperty("scroll-margin-top");
      });
      links.forEach((link) => {
        link.classList.remove("is-active");
        link.removeAttribute("aria-current");
      });
      delete root.dataset.ffQuickAccessInit;
    });
  }


  /* ========== REINTRO PASS 7 — interactive content bundle ========== */

  /* ========== TABS PARALLAX ========== */

  function initFfTabsParallax(root) {
    qsa(root, "[data-ff-tabs-parallax]").forEach((sectionEl) => {
      if (sectionEl.dataset.ffTabsParallaxInit === "true") return;
      sectionEl.dataset.ffTabsParallaxInit = "true";
      setupFfTabsParallax(sectionEl);
    });
  }

  function setupFfTabsParallax(sectionEl) {
    const desktopEl = sectionEl.querySelector(".ff-tabs-parallax__desktop");
    const tabViewport = desktopEl ? desktopEl.querySelector("[data-ff-tab-viewport]") : null;
    const prevButton = desktopEl ? desktopEl.querySelector(".ff-tabs-parallax__scroll-control.is-prev") : null;
    const nextButton = desktopEl ? desktopEl.querySelector(".ff-tabs-parallax__scroll-control.is-next") : null;
    const tabButtons = desktopEl ? Array.from(desktopEl.querySelectorAll(".ff-tabs-parallax__tab-button")) : [];
    const tabPanels = desktopEl ? Array.from(desktopEl.querySelectorAll(".ff-tabs-parallax__desktop-panel")) : [];

    const ac = "AbortController" in window ? new AbortController() : null;
    const cleanupFns = [];
    const bind = (target, eventName, handler, options) => {
      target.addEventListener(eventName, handler, options);
      if (!ac) cleanupFns.push(() => target.removeEventListener(eventName, handler, options));
    };

    const listenerOptions = ac ? { signal: ac.signal } : undefined;
    const passiveListenerOptions = ac ? { passive: true, signal: ac.signal } : { passive: true };
    const wheelOptions = ac ? { passive: false, signal: ac.signal } : { passive: false };
    const mqDesktop = window.matchMedia("(min-width: 1000px)");
    let removeMqListener = null;
    let rafId = 0;

    const isDesktop = () => mqDesktop.matches;
    const isScrollLayout = () => desktopEl && desktopEl.classList.contains("ff-tabs-parallax__desktop--scroll");

    const updateScrollState = () => {
      rafId = 0;

      if (!desktopEl || !tabViewport || !isScrollLayout() || !isDesktop()) {
        if (desktopEl) desktopEl.classList.remove("is-overflowing", "is-start", "is-end");
        return;
      }

      const overflow = tabViewport.scrollWidth > tabViewport.clientWidth + 2;
      const atStart = tabViewport.scrollLeft <= 2;
      const atEnd = tabViewport.scrollLeft + tabViewport.clientWidth >= tabViewport.scrollWidth - 2;

      desktopEl.classList.toggle("is-overflowing", overflow);
      desktopEl.classList.toggle("is-start", atStart);
      desktopEl.classList.toggle("is-end", atEnd);
    };

    const queueUpdateScrollState = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(updateScrollState);
    };

    const activateTab = (index, options = {}) => {
      const settings = { focus: false, scroll: false, ...options };
      if (!tabButtons.length || !tabPanels.length) return;
      if (index < 0 || index >= tabButtons.length) return;

      tabButtons.forEach((button, buttonIndex) => {
        const isActive = buttonIndex === index;
        button.setAttribute("aria-selected", isActive ? "true" : "false");
        button.tabIndex = isActive ? 0 : -1;
      });

      tabPanels.forEach((panel, panelIndex) => {
        panel.hidden = panelIndex !== index;
      });

      const activeButton = tabButtons[index];
      if (!activeButton) return;
      if (settings.focus) activeButton.focus();

      if (settings.scroll && tabViewport && isScrollLayout() && isDesktop()) {
        const reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        activeButton.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", inline: "nearest", block: "nearest" });
      }

      queueUpdateScrollState();
    };

    if (tabButtons.length && tabPanels.length) {
      tabButtons.forEach((button, index) => {
        bind(button, "click", () => {
          activateTab(index, { scroll: true });
        }, listenerOptions);

        bind(button, "keydown", (event) => {
          let targetIndex = null;

          switch (event.key) {
            case "ArrowRight":
            case "ArrowDown":
              targetIndex = (index + 1) % tabButtons.length;
              break;
            case "ArrowLeft":
            case "ArrowUp":
              targetIndex = (index - 1 + tabButtons.length) % tabButtons.length;
              break;
            case "Home":
              targetIndex = 0;
              break;
            case "End":
              targetIndex = tabButtons.length - 1;
              break;
          }

          if (targetIndex === null) return;
          event.preventDefault();
          activateTab(targetIndex, { focus: true, scroll: true });
        }, listenerOptions);
      });
    }

    if (prevButton && tabViewport) {
      bind(prevButton, "click", () => {
        const reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        tabViewport.scrollBy({
          left: -Math.max(220, Math.round(tabViewport.clientWidth * 0.45)),
          behavior: reduceMotion ? "auto" : "smooth"
        });
      }, listenerOptions);
    }

    if (nextButton && tabViewport) {
      bind(nextButton, "click", () => {
        const reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        tabViewport.scrollBy({
          left: Math.max(220, Math.round(tabViewport.clientWidth * 0.45)),
          behavior: reduceMotion ? "auto" : "smooth"
        });
      }, listenerOptions);
    }

    if (tabViewport) {
      bind(tabViewport, "scroll", queueUpdateScrollState, passiveListenerOptions);
      bind(tabViewport, "wheel", (event) => {
        if (!isDesktop() || !isScrollLayout()) return;

        const overflow = tabViewport.scrollWidth > tabViewport.clientWidth + 2;
        if (!overflow) return;
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

        event.preventDefault();
        tabViewport.scrollLeft += event.deltaY;
      }, wheelOptions);
    }

    bind(window, "resize", queueUpdateScrollState, passiveListenerOptions);
    bind(window, "load", queueUpdateScrollState, listenerOptions);

    const onMqChange = () => queueUpdateScrollState();
    if (mqDesktop.addEventListener) {
      mqDesktop.addEventListener("change", onMqChange);
      removeMqListener = () => mqDesktop.removeEventListener("change", onMqChange);
    } else if (mqDesktop.addListener) {
      mqDesktop.addListener(onMqChange);
      removeMqListener = () => mqDesktop.removeListener(onMqChange);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        if (!sectionEl.isConnected) return;
        queueUpdateScrollState();
      });
    }

    if (window.Shopify && Shopify.designMode) {
      const onBlockSelect = (event) => {
        const blockEl = event.target.closest("[data-ff-panel-index], [data-ff-accordion-index]");
        if (!blockEl || !sectionEl.contains(blockEl)) return;

        const rawIndex = blockEl.getAttribute("data-ff-panel-index") || blockEl.getAttribute("data-ff-accordion-index");
        const index = Number(rawIndex);
        if (Number.isNaN(index)) return;

        if (isDesktop()) {
          activateTab(index, { scroll: true });
        } else {
          const accordionItem = sectionEl.querySelector('[data-ff-accordion-index="' + index + '"]');
          if (accordionItem) accordionItem.open = true;
        }
      };

      bind(document, "shopify:block:select", onBlockSelect, listenerOptions);
    }

    queueUpdateScrollState();

    registerCleanup(sectionEl, () => {
      if (rafId) cancelAnimationFrame(rafId);
      if (removeMqListener) removeMqListener();
      if (ac) ac.abort();
      cleanupFns.forEach((cleanup) => {
        try {
          cleanup();
        } catch (_) {}
      });
      delete sectionEl.dataset.ffTabsParallaxInit;
    });
  }

  /* ========== PARALLAX MULTI-COLUMN (built-in bg mode) ========== */

  function initFfParallaxMultiColumn(root) {
    qsa(root, "[data-ff-parallax-multi-column]").forEach((sectionEl) => {
      if (sectionEl.dataset.ffParallaxMultiColumnInit === "true") return;
      sectionEl.dataset.ffParallaxMultiColumnInit = "true";
      setupFfParallaxMultiColumn(sectionEl);
    });
  }

  function setupFfParallaxMultiColumn(root) {
    if (!root.classList.contains("ff-parallax-multi-column--builtin-bg")) return;
    if (root.getAttribute("data-parallax") !== "on") return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const layer = root.querySelector(".ffpmc-bg-layer");
    if (!layer) return;

    const ac = "AbortController" in window ? new AbortController() : null;
    const cleanupFns = [];
    const bind = (target, eventName, handler, options) => {
      target.addEventListener(eventName, handler, options);
      if (!ac) cleanupFns.push(() => target.removeEventListener(eventName, handler, options));
    };

    const passiveListenerOptions = ac ? { passive: true, signal: ac.signal } : { passive: true };
    let rafId = 0;

    const strengthToken = parseFloat(root.getAttribute("data-parallax-strength") || "15");
    const maxShift = Math.max(0, Math.min(strengthToken, 40)) * 6;

    const update = () => {
      rafId = 0;

      if (window.innerWidth < 700) {
        layer.style.transform = "translate3d(0,0,0)";
        return;
      }

      const rect = root.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const mid = rect.top + rect.height * 0.5;
      const t = (mid - vh * 0.5) / vh;
      const shift = Math.max(-maxShift, Math.min(maxShift, -t * maxShift));

      layer.style.transform = "translate3d(0," + shift.toFixed(2) + "px,0)";
    };

    const queueUpdate = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(update);
    };

    queueUpdate();
    bind(window, "scroll", queueUpdate, passiveListenerOptions);
    bind(window, "resize", queueUpdate, passiveListenerOptions);

    registerCleanup(root, () => {
      if (rafId) cancelAnimationFrame(rafId);
      if (ac) ac.abort();
      cleanupFns.forEach((cleanup) => {
        try {
          cleanup();
        } catch (_) {}
      });
      layer.style.removeProperty("transform");
      delete root.dataset.ffParallaxMultiColumnInit;
    });
  }

  function initFfCareBlog(root) {
    qsa(root, "[data-ff-care-blog]").forEach((section) => {
      if (section.dataset.ffCareBlogInit === "1") return;
      section.dataset.ffCareBlogInit = "1";

      const cleanups = [];
      const ownerToken = nextId("ff-care-blog");
      const body = document.body;

      if (body) {
        body.dataset.ffCareBlogOwner = ownerToken;
        body.dataset.ffCareBlogBg = section.dataset.ffCareBlogBg || "0";

        const bgUrl = section.dataset.ffCareBlogBgUrl || "";
        if (bgUrl) {
          const safeUrl = bgUrl.replace(/"/g, '\\"');
          body.style.setProperty("--ff-care-blog-bg-image", 'url("' + safeUrl + '")');
        } else {
          body.style.removeProperty("--ff-care-blog-bg-image");
        }

        body.style.setProperty(
          "--ff-care-blog-bg-attachment",
          section.dataset.ffCareBlogParallax === "1" ? "fixed" : "scroll"
        );

        cleanups.push(() => {
          if (!document.body || document.body.dataset.ffCareBlogOwner !== ownerToken) return;
          document.body.removeAttribute("data-ff-care-blog-bg");
          document.body.removeAttribute("data-ff-care-blog-owner");
          document.body.style.removeProperty("--ff-care-blog-bg-image");
          document.body.style.removeProperty("--ff-care-blog-bg-attachment");
        });
      }

      const shell = section.querySelector(".ff-care-filters-shell");
      const toggle = shell ? shell.querySelector(".ff-care-filters-toggle") : null;
      if (shell && toggle) {
        const onClick = function () {
          const isOpen = shell.classList.toggle("ff-care-filters-shell--open");
          toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
        };
        toggle.addEventListener("click", onClick);
        cleanups.push(() => toggle.removeEventListener("click", onClick));
      }

      registerCleanup(section, () => {
        cleanups.forEach((cleanup) => {
          try {
            cleanup();
          } catch (_) {}
        });
        delete section.dataset.ffCareBlogInit;
      });
    });
  }

  function initFfRichTextCollapsibles(root) {
  qsa(root, "[data-ff-richtext-collapsible]").forEach((section) => {
    if (section.dataset.ffRichtextCollapsibleInit === "1") return;
    section.dataset.ffRichtextCollapsibleInit = "1";

    const readMore = section.dataset.ffReadMore || "Read more";
    const readLess = section.dataset.ffReadLess || "Show less";
    const cleanups = [];

    section.querySelectorAll("[data-collapsible-toggle]").forEach((toggle) => {
      const container = toggle.closest(".ff-collapsible");
      if (!container) return;

      const content = container.querySelector("[data-collapsible-content]");
      if (!content) return;

      let expanded = container.classList.contains("is-expanded");
      let resizeTimer = null;

      const syncButton = () => {
        toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
        toggle.textContent = expanded ? readLess : readMore;
      };

      const measureOverflow = () => {
        const wasExpanded = container.classList.contains("is-expanded");

        container.classList.remove("is-expanded");
        container.classList.remove("is-not-collapsible");
        container.classList.add("is-collapsible");

        const canCollapse = content.scrollHeight > content.clientHeight + 4;

        container.classList.toggle("is-collapsible", canCollapse);
        container.classList.toggle("is-not-collapsible", !canCollapse);

        if (wasExpanded && canCollapse) {
          container.classList.add("is-expanded");
        }

        if (!canCollapse) {
          expanded = false;
          container.classList.remove("is-expanded");
        }

        toggle.hidden = !canCollapse;
        syncButton();
      };

      const scheduleMeasure = () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(() => {
          window.requestAnimationFrame(measureOverflow);
        }, 80);
      };

      const onClick = () => {
        expanded = !expanded;
        container.classList.toggle("is-expanded", expanded);
        syncButton();
      };

      const onResize = () => {
        scheduleMeasure();
      };

      toggle.addEventListener("click", onClick);
      window.addEventListener("resize", onResize, { passive: true });

      let resizeObserver = null;

      if ("ResizeObserver" in window) {
        resizeObserver = new ResizeObserver(scheduleMeasure);
        resizeObserver.observe(content);
      }

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(scheduleMeasure).catch(() => {});
      }

      window.requestAnimationFrame(measureOverflow);

      cleanups.push(() => {
        toggle.removeEventListener("click", onClick);
        window.removeEventListener("resize", onResize);
        window.clearTimeout(resizeTimer);

        if (resizeObserver) {
          try {
            resizeObserver.disconnect();
          } catch (_) {}
        }
      });
    });

    registerCleanup(section, () => {
      cleanups.forEach((cleanup) => {
        try {
          cleanup();
        } catch (_) {}
      });
      delete section.dataset.ffRichtextCollapsibleInit;
    });
  });
}
  /* =========================================
     PRODUCT CARD: MOBILE TAP REVEAL
     - first tap reveals quick action + secondary image
     - second tap follows product link normally
     - action buttons/forms remain usable
  ========================================== */
  let ffProductCardTapRevealInit = false;

  function initFfProductCardTapReveal() {
    if (ffProductCardTapRevealInit) return;
    ffProductCardTapRevealInit = true;

    const touchQuery = window.matchMedia("(hover: none), (pointer: coarse)");
    const cardSelector = 'product-card[data-ff-card-tap-reveal="true"]';

    const closeCards = (activeCard) => {
      document.querySelectorAll(`${cardSelector}.is-ff-card-tapped`).forEach((card) => {
        if (card !== activeCard) {
          card.classList.remove("is-ff-card-tapped");
        }
      });
    };

    const isActionTarget = (target) => {
      return !!(
        target &&
        target.closest &&
        target.closest(
          '[data-ff-card-action], button, input, select, textarea, summary, [role="button"], [aria-controls]'
        )
      );
    };

    document.addEventListener(
      "click",
      (event) => {
        if (!touchQuery.matches) return;

        const card = event.target.closest(cardSelector);

        if (!card) {
          closeCards(null);
          return;
        }

        if (isActionTarget(event.target)) return;

        if (!card.classList.contains("is-ff-card-tapped")) {
          event.preventDefault();
          event.stopPropagation();

          closeCards(card);

          const secondary = card.querySelector(
            'img.product-card__image--secondary[data-src], img.product-card__image--secondary[data-srcset], img.product-card__image--secondary[data-sizes]'
          );

          if (secondary) {
            secondary.dispatchEvent(new Event("ff:load-secondary", { bubbles: true }));
          }

          card.classList.add("is-ff-card-tapped");
        }
      },
      true
    );

    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      closeCards(null);
    });
  }

/* ========== SHIPPING POLICY TABLES (FF) ========== */

function sortFfShippingPolicyTables(root) {
  const scope = root || document;
  const locale = document.documentElement.lang || undefined;
  const collator = new Intl.Collator(locale, { sensitivity: "base" });

  scope.querySelectorAll("[data-ff-shipping-policy-table] tbody").forEach((body) => {
    Array.from(body.rows)
      .sort((a, b) => collator.compare(
        a.cells[0]?.textContent.trim() || "",
        b.cells[0]?.textContent.trim() || ""
      ))
      .forEach((row) => body.appendChild(row));
  });
}

/* ========== LAZY MODALS (FF) ========== */

let ffLazyModalDelegationInit = false;

function initFfLazyModals() {
  if (ffLazyModalDelegationInit) return;
  ffLazyModalDelegationInit = true;

  document.addEventListener("dialog:before-show", function (event) {
    const modal = event.target;
    if (!modal.matches?.('[data-ff-lazy-modal="true"]')) return;
    queueMicrotask(function () {
      if (!modal.open || !modal.isConnected) return;
      modal.focusTrap?.activate();
    });
  }, true);

  document.addEventListener("dialog:after-show", function (event) {
    const modal = event.target;
    if (!modal.matches?.('[data-ff-lazy-modal="true"]') || !modal.open) return;
    if (modal.contains(document.activeElement)) return;
    modal.querySelector("[data-ff-modal-title]")?.focus({ preventScroll: true });
  }, true);

  async function loadLazyModal(modal) {
    if (!modal) return;
    if (modal.dataset.ffModalLoaded === "true") return;
    if (modal.dataset.ffModalLoading === "true") return;

    const src = modal.dataset.ffModalSrc;
    const selector = modal.dataset.ffModalSelector || "#ff-shipping-table-source";
    const body = modal.querySelector("[data-ff-modal-body]");

    if (!src || !body) return;

    modal.dataset.ffModalLoading = "true";
    body.setAttribute("aria-busy", "true");

    // Preserve keyboard focus when the active Retry control becomes disabled.
    // Without this, disabling the focused button moves focus out of the dialog.
    const existingRetry = body.querySelector("[data-ff-modal-retry]");
    const restoreRetryFocus = existingRetry != null && document.activeElement === existingRetry;
    const modalIsOpen = () => modal.isConnected && (modal.open === undefined || modal.open);
    const focusWithoutScroll = (element) => {
      if (!element || !modalIsOpen()) return;
      element.focus({ preventScroll: true });
    };
    const existingFailure = body.querySelector("[data-ff-modal-error]");
    if (existingFailure) existingFailure.hidden = true;
    body.querySelectorAll("[data-ff-modal-status]").forEach((node) => node.remove());

    const status = document.createElement("p");
    status.className = "text-sm text-subdued ff-shipping-modal-status";
    status.dataset.ffModalStatus = "true";
    status.setAttribute("role", "status");
    status.textContent = modal.dataset.ffModalLoadingLabel || "Loading shipping information…";
    if (restoreRetryFocus) status.tabIndex = -1;
    body.prepend(status);
    if (restoreRetryFocus) focusWithoutScroll(status);
    if (existingRetry) {
      existingRetry.disabled = true;
      existingRetry.setAttribute("aria-busy", "true");
    }

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 15000);

    try {
      const response = await fetch(src, {
        credentials: "same-origin",
        headers: { "X-Requested-With": "XMLHttpRequest" },
        signal: controller.signal
      });

      if (!response.ok) {
        throw new Error("HTTP " + response.status);
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const source = doc.querySelector(selector);

      if (!source) {
        throw new Error("Missing selector: " + selector);
      }

      const shouldRestoreFocus = modalIsOpen() && body.contains(document.activeElement);
      body.innerHTML = source.innerHTML;
      if (shouldRestoreFocus && modalIsOpen()) {
        // The loading status was removed. Return keyboard focus to the loaded
        // information instead of leaving it on the document body.
        const heading = body.querySelector("h1, h2, h3, h4") || body;
        if (!heading.hasAttribute("tabindex")) heading.tabIndex = -1;
        focusWithoutScroll(heading);
      }

      // Keep modal tables in the same locale-aware alphabetical order as the full page.
      sortFfShippingPolicyTables(body);

      // Wrap any injected prose tables the same way the rest of FF UI does
      wrapProseTables(modal);

      modal.dataset.ffModalLoaded = "true";
    } catch (error) {
      console.error("FF lazy modal failed:", error);

      const message = document.createElement("p");
      message.className = "text-sm text-subdued";
      message.dataset.ffModalError = "true";
      message.setAttribute("role", "alert");
      message.textContent = modal.dataset.ffModalErrorMessage ||
        "Shipping information could not be loaded. Please try again.";

      const actions = document.createElement("div");
      actions.className = "ff-shipping-modal-recovery";

      const retry = document.createElement("button");
      retry.type = "button";
      retry.className = "button button--sm button--outline";
      retry.dataset.ffModalRetry = "true";
      retry.textContent = modal.dataset.ffModalRetryLabel || "Try again";
      retry.addEventListener("click", () => loadLazyModal(modal));
      actions.appendChild(retry);

      const policyUrl = modal.dataset.ffModalPolicyUrl;
      if (policyUrl && policyUrl.startsWith("/")) {
        const link = document.createElement("a");
        link.className = "link";
        link.href = policyUrl;
        link.textContent = modal.dataset.ffModalPolicyLabel || "View shipping & delivery";
        actions.appendChild(link);
      }

      const shouldRestoreFocus = modalIsOpen() && body.contains(document.activeElement);
      body.replaceChildren(message, actions);
      if (shouldRestoreFocus) focusWithoutScroll(retry);
      modal.dataset.ffModalLoaded = "error";
    } finally {
      clearTimeout(timeoutId);
      body.setAttribute("aria-busy", "false");
      delete modal.dataset.ffModalLoading;
    }
  }

  function getLazyModalFromTriggerTarget(target) {
    if (!target || !target.closest) return null;

    const trigger = target.closest("[aria-controls]");
    if (!trigger) return null;

    const modalId = trigger.getAttribute("aria-controls");
    if (!modalId) return null;

    const modal = document.getElementById(modalId);
    if (!modal) return null;
    if (modal.dataset.ffLazyModal !== "true") return null;

    return modal;
  }

  document.addEventListener("click", function (event) {
    const modal = getLazyModalFromTriggerTarget(event.target);
    if (modal) loadLazyModal(modal);
  });
}


  /* ========== SCROLL STORY (FF) ========== */

function initFfScrollStory(root) {
  qsa(root, "[data-ff-scroll-story]").forEach((section) => {
    if (section.dataset.ffScrollStoryInit === "true") return;

    const scroller = section.querySelector("[data-ffss-scroller]");
    const stage = section.querySelector("[data-ffss-stage]");
    const introCard = section.querySelector("[data-ffss-intro-card]");
    const stepCards = Array.from(section.querySelectorAll("[data-ffss-step-card]"));
    const stepMedia = Array.from(section.querySelectorAll("[data-ffss-step-media]"));

    const mobileStepper = section.querySelector("[data-ffss-mobile-stepper]");
    const mobileSlides = Array.from(section.querySelectorAll("[data-ffss-mobile-slide]"));
    const mobilePrev = section.querySelector("[data-ffss-mobile-prev]");
    const mobileNext = section.querySelector("[data-ffss-mobile-next]");
    const mobileDots = Array.from(section.querySelectorAll("[data-ffss-mobile-dot]"));
    const mobileCurrent = section.querySelector("[data-ffss-mobile-current]");
    const mobileTotal = section.querySelector("[data-ffss-mobile-total]");

    if (!scroller || !stage || !introCard || !stepCards.length) return;

    section
      .querySelectorAll(".ff-scroll-story__desktop .ff-scroll-story__step-image, .ff-scroll-story__desktop .ff-scroll-story__base-image")
      .forEach((img) => {
        try {
          img.loading = "eager";
          img.decoding = "async";

          if ("fetchPriority" in img) {
            img.fetchPriority = "low";
          }

          if (typeof img.decode === "function") {
            img.decode().catch(() => {});
          }
        } catch (_) {}
      });

    section.dataset.ffScrollStoryInit = "true";

    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const desktop = window.matchMedia("(min-width: 1000px)");
    const stateCount = stepCards.length + 1;

    let raf = null;
    let currentState = -1;
    let mobileIndex = 0;
    let touchStartX = 0;
    let touchEndX = 0;

    const shouldEnhanceDesktop = () => desktop.matches && !reduceMotion.matches;

    const setInert = (element, inertState) => {
      if (!element) return;

      element.setAttribute("aria-hidden", inertState ? "true" : "false");

      try {
        element.inert = inertState;
      } catch (_) {}
    };

    const setActiveState = (stateIndex, scrollToState = false) => {
      stateIndex = Math.min(Math.max(stateIndex, 0), stateCount - 1);
      currentState = stateIndex;

      const introActive = stateIndex === 0;
      const activeStepIndex = stateIndex - 1;

      section.classList.toggle("is-intro-state", introActive);
      section.classList.toggle("is-step-state", !introActive);

      setInert(introCard, !introActive);

      stepCards.forEach((card, index) => {
        const isActive = !introActive && index === activeStepIndex;
        card.classList.toggle("is-active", isActive);
        setInert(card, !isActive);
      });

      stepMedia.forEach((media, index) => {
        const isActive = !introActive && index === activeStepIndex;
        media.classList.toggle("is-active", isActive);
        media.setAttribute("aria-hidden", isActive ? "false" : "true");
      });

      if (scrollToState && shouldEnhanceDesktop()) {
        const stickyTop = parseFloat(getComputedStyle(stage).top) || 0;
        const maxScroll = Math.max(1, scroller.offsetHeight - stage.offsetHeight);
        const targetProgress = stateCount === 1 ? 0 : stateIndex / (stateCount - 1);
        const sectionTop = window.scrollY + scroller.getBoundingClientRect().top;
        const targetY = sectionTop - stickyTop + maxScroll * targetProgress;

        window.scrollTo({
          top: targetY,
          behavior: "smooth"
        });
      }
    };

    const updateDesktop = () => {
      raf = null;

      if (!shouldEnhanceDesktop()) {
        setActiveState(0);
        return;
      }

      const stickyTop = parseFloat(getComputedStyle(stage).top) || 0;
      const rect = scroller.getBoundingClientRect();
      const maxScroll = Math.max(1, scroller.offsetHeight - stage.offsetHeight);
      const progress = Math.min(Math.max((stickyTop - rect.top) / maxScroll, 0), 1);
      const nextState = Math.min(Math.max(Math.floor(progress * stateCount), 0), stateCount - 1);

      if (nextState !== currentState) {
        setActiveState(nextState);
      }
    };

    const requestDesktopUpdate = () => {
      if (raf) return;
      raf = window.requestAnimationFrame(updateDesktop);
    };

    const setMobileSlide = (index) => {
      if (!mobileSlides.length) return;

      mobileIndex = Math.min(Math.max(index, 0), mobileSlides.length - 1);

      mobileSlides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === mobileIndex;
        slide.classList.toggle("is-active", isActive);
        slide.hidden = !isActive;
        slide.setAttribute("aria-hidden", isActive ? "false" : "true");
      });

      mobileDots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === mobileIndex;
        dot.classList.toggle("is-active", isActive);
        dot.setAttribute("aria-current", isActive ? "true" : "false");
        dot.setAttribute("aria-selected", isActive ? "true" : "false");
        dot.tabIndex = isActive ? 0 : -1;
      });

      if (mobilePrev) mobilePrev.disabled = mobileIndex === 0;
      if (mobileNext) mobileNext.disabled = mobileIndex === mobileSlides.length - 1;

      if (mobileCurrent) mobileCurrent.textContent = String(mobileIndex + 1);
      if (mobileTotal) mobileTotal.textContent = String(mobileSlides.length);
    };

    const goMobilePrev = () => setMobileSlide(mobileIndex - 1);
    const goMobileNext = () => setMobileSlide(mobileIndex + 1);

    const onMobileKeydown = (event) => {
      if (!mobileStepper || desktop.matches) return;

      if (event.key === "ArrowLeft") {
        event.preventDefault();
        goMobilePrev();
      }

      if (event.key === "ArrowRight") {
        event.preventDefault();
        goMobileNext();
      }
    };

    const onTouchStart = (event) => {
      if (!mobileStepper || desktop.matches) return;
      touchStartX = event.changedTouches[0].screenX;
    };

    const onTouchEnd = (event) => {
      if (!mobileStepper || desktop.matches) return;

      touchEndX = event.changedTouches[0].screenX;
      const delta = touchStartX - touchEndX;

      if (Math.abs(delta) < 45) return;

      if (delta > 0) {
        goMobileNext();
      } else {
        goMobilePrev();
      }
    };

    const onBlockSelect = (event) => {
      const blockId = event.detail && event.detail.blockId;
      if (!blockId) return;

      const desktopCard = section.querySelector(`[data-ffss-block-id="${blockId}"]`);
      const mobileSlide = section.querySelector(`[data-ffss-mobile-block-id="${blockId}"]`);

      if (desktop.matches && desktopCard) {
        const index = stepCards.indexOf(desktopCard);
        if (index >= 0) setActiveState(index + 1, true);
        return;
      }

      if (!desktop.matches && mobileSlide) {
        const index = mobileSlides.indexOf(mobileSlide);
        if (index >= 0) setMobileSlide(index);
      }
    };

    window.addEventListener("scroll", requestDesktopUpdate, { passive: true });
    window.addEventListener("resize", requestDesktopUpdate);

    if (reduceMotion.addEventListener) {
      reduceMotion.addEventListener("change", requestDesktopUpdate);
    } else if (reduceMotion.addListener) {
      reduceMotion.addListener(requestDesktopUpdate);
    }

    if (desktop.addEventListener) {
      desktop.addEventListener("change", requestDesktopUpdate);
    } else if (desktop.addListener) {
      desktop.addListener(requestDesktopUpdate);
    }

    if (mobilePrev) mobilePrev.addEventListener("click", goMobilePrev);
    if (mobileNext) mobileNext.addEventListener("click", goMobileNext);

    mobileDots.forEach((dot, index) => {
      dot.addEventListener("click", () => setMobileSlide(index));
    });

    if (mobileStepper) {
      mobileStepper.addEventListener("keydown", onMobileKeydown);
      mobileStepper.addEventListener("touchstart", onTouchStart, { passive: true });
      mobileStepper.addEventListener("touchend", onTouchEnd, { passive: true });
    }

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener("shopify:block:select", onBlockSelect);
    }

    setActiveState(0);
    setMobileSlide(0);
    requestDesktopUpdate();

    registerCleanup(section, () => {
      window.removeEventListener("scroll", requestDesktopUpdate);
      window.removeEventListener("resize", requestDesktopUpdate);

      if (reduceMotion.removeEventListener) {
        reduceMotion.removeEventListener("change", requestDesktopUpdate);
      } else if (reduceMotion.removeListener) {
        reduceMotion.removeListener(requestDesktopUpdate);
      }

      if (desktop.removeEventListener) {
        desktop.removeEventListener("change", requestDesktopUpdate);
      } else if (desktop.removeListener) {
        desktop.removeListener(requestDesktopUpdate);
      }

      if (mobilePrev) mobilePrev.removeEventListener("click", goMobilePrev);
      if (mobileNext) mobileNext.removeEventListener("click", goMobileNext);

      if (mobileStepper) {
        mobileStepper.removeEventListener("keydown", onMobileKeydown);
        mobileStepper.removeEventListener("touchstart", onTouchStart);
        mobileStepper.removeEventListener("touchend", onTouchEnd);
      }

      if (window.Shopify && Shopify.designMode) {
        document.removeEventListener("shopify:block:select", onBlockSelect);
      }

      if (raf) {
        window.cancelAnimationFrame(raf);
      }

      stepCards.forEach((card) => {
        card.classList.remove("is-active");
        setInert(card, false);
      });

      stepMedia.forEach((media) => {
        media.classList.remove("is-active");
        media.setAttribute("aria-hidden", "true");
      });

      introCard.removeAttribute("aria-hidden");

      try {
        introCard.inert = false;
      } catch (_) {}

      section.classList.remove("is-intro-state", "is-step-state");
      delete section.dataset.ffScrollStoryInit;
    });
  });
}


  function initFfProductGalleryA11y(root) {
    const navigations = Array.from(
      root.querySelectorAll
        ? root.querySelectorAll("product-gallery-navigation")
        : []
    );

    if (root.matches && root.matches("product-gallery-navigation")) {
      navigations.unshift(root);
    }

    navigations.forEach((navigation) => {
      if (navigation.dataset.ffGalleryA11yInit === "true") return;
      navigation.dataset.ffGalleryA11yInit = "true";

      const getButtons = () =>
        Array.from(
          navigation.querySelectorAll("[data-ff-gallery-thumbnail]")
        ).filter((button) => !button.hidden);

      const syncTabStops = () => {
        const buttons = getButtons();
        const selected =
          buttons.find((button) => button.getAttribute("aria-current") === "true") ||
          buttons[0];

        buttons.forEach((button) => {
          button.tabIndex = button === selected ? 0 : -1;
        });
      };

      const onKeydown = (event) => {
        if (
          !["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)
        ) {
          return;
        }

        const buttons = getButtons();
        const currentIndex = buttons.indexOf(document.activeElement);
        if (currentIndex < 0 || !buttons.length) return;

        event.preventDefault();

        let nextIndex = currentIndex;
        const rtl = document.documentElement.dir === "rtl";

        if (event.key === "Home") nextIndex = 0;
        if (event.key === "End") nextIndex = buttons.length - 1;
        if (event.key === "ArrowRight") {
          nextIndex = (currentIndex + (rtl ? -1 : 1) + buttons.length) % buttons.length;
        }
        if (event.key === "ArrowLeft") {
          nextIndex = (currentIndex + (rtl ? 1 : -1) + buttons.length) % buttons.length;
        }

        buttons[nextIndex].tabIndex = 0;
        buttons[nextIndex].focus();
        buttons[nextIndex].click();
      };

      const observer = new MutationObserver(syncTabStops);
      observer.observe(navigation, {
        subtree: true,
        attributes: true,
        attributeFilter: ["aria-current", "hidden"]
      });

      navigation.addEventListener("keydown", onKeydown);
      syncTabStops();

      registerCleanup(navigation, () => {
        observer.disconnect();
        navigation.removeEventListener("keydown", onKeydown);
        delete navigation.dataset.ffGalleryA11yInit;
      });
    });
  }

  function initFfQuantityLimits(root) {
    const selectors = Array.from(
      root.querySelectorAll ? root.querySelectorAll("quantity-selector") : []
    );

    if (root.matches && root.matches("quantity-selector")) selectors.unshift(root);

    selectors.forEach((selector) => {
      if (selector.dataset.ffQuantityLimitInit === "true") return;

      const input = selector.querySelector('input[type="number"][max]');
      if (!input) return;

      selector.dataset.ffQuantityLimitInit = "true";
      const buttons = selector.querySelectorAll(".quantity-selector__button");
      const plusButton = buttons[buttons.length - 1];
      const statusId = input.getAttribute("aria-describedby");
      const status = statusId ? document.getElementById(statusId) : null;

      const update = () => {
        const maximum = Number(input.max);
        let value = Number(input.value);
        if (!Number.isFinite(maximum)) return;

        if (Number.isFinite(value) && value > maximum) {
          value = maximum;
          input.value = String(maximum);
        }

        const atMaximum = Number.isFinite(value) && value >= maximum;
        if (plusButton) plusButton.disabled = atMaximum;
        if (status) status.hidden = !atMaximum;
      };

      const scheduleUpdate = () => requestAnimationFrame(update);
      input.addEventListener("input", scheduleUpdate);
      input.addEventListener("change", scheduleUpdate);
      if (plusButton) plusButton.addEventListener("click", scheduleUpdate);
      update();

      registerCleanup(selector, () => {
        input.removeEventListener("input", scheduleUpdate);
        input.removeEventListener("change", scheduleUpdate);
        if (plusButton) plusButton.removeEventListener("click", scheduleUpdate);
        delete selector.dataset.ffQuantityLimitInit;
      });
    });
  }


  /* Shopify editor + dynamic markup: Plant Finder form */
  function initFfPlantFinderForms(scope) {
    qsa(scope, '[data-ff-pf-root]').forEach((root) => {
      if (root.dataset.ffPfReady === 'true') return;
      const form = root.querySelector('[data-ff-pf-form]');
      const summary = root.querySelector('[data-ff-pf-summary]');
      const submit = root.querySelector('[data-ff-pf-submit]');
      if (!form || !summary || !submit) return;
      root.dataset.ffPfReady = 'true';
      const controls = Array.from(root.querySelectorAll('[data-ff-plant-finder-select], [data-ff-plant-finder-toggle]'));
      const selects = Array.from(root.querySelectorAll('[data-ff-plant-finder-select]'));
      const toggles = Array.from(root.querySelectorAll('[data-ff-plant-finder-toggle]'));
      const summaryPrefix = root.dataset.ffPfSummaryPrefix || 'Selected:';
      const summaryEmpty = root.dataset.ffPfSummaryEmpty || 'No filters selected yet.';
      const submitDefault = root.dataset.ffPfSubmitDefault || submit.textContent.trim();
      const submitSelected = root.dataset.ffPfSubmitSelected || 'Show plants with {count} selected filters';
      const submitOne = root.dataset.ffPfSubmitOne || submitSelected;
      const removeTemplate = root.dataset.ffPfRemoveFilterLabel || 'Remove {label}';
      const selectedValues = new Map();

      const escapeSelector = (value) => {
        if (window.CSS && typeof CSS.escape === 'function') {
          return CSS.escape(value);
        }

        return String(value).replace(/["\\]/g, '\\$&');
      };

      const decodeHtml = (value) => {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = String(value || '');
        return textarea.value;
      };

      const normalizeValue = (value) => {
        return decodeHtml(value)
          .trim()
          .replace(/\s+/g, ' ');
      };

      const canonicalOptions = (select) => Array.from(
        select.closest('.ff-plant-finder__field')?.querySelector('[data-ff-pf-canonical-options]')?.content.querySelectorAll('option') || []
      );

      const canonicalOption = (select, value) => {
        const normalized = normalizeValue(value);
        if (!normalized) return null;
        return canonicalOptions(select).find((option) => [
          option.value, option.dataset.ffPfEnValue, option.dataset.ffPfDeValue, option.textContent
        ].some((candidate) => normalizeValue(candidate) === normalized));
      };

      const readUrlParams = (url) => {
        const params = new URLSearchParams();
        url.search.slice(1).split('&').forEach((part) => {
          if (!part) return;
          const entry = new URLSearchParams(part).entries().next().value;
          if (!entry) return;
          const [name, value] = entry;
          if (!name.startsWith('filter.')) {
            params.append(name, value);
            return;
          }
          const separator = part.indexOf('=');
          const rawValue = separator < 0 ? '' : part.slice(separator + 1);
          rawValue.split(',').forEach((item) => {
            params.append(name, new URLSearchParams(`value=${item}`).get('value'));
          });
        });
        return params;
      };

      const resolveOption = (select, rawValue) => {
        const raw = String(rawValue || '');
        if (!raw) return null;
        const normalized = normalizeValue(raw);
        const options = Array.from(select.options);
        const canonical = canonicalOption(select, raw);
        let match = options.find((option) => option.value === raw) ||
          options.find((option) => normalizeValue(option.value) === normalized);
        if (!match && canonical) {
          match = options.find((option) => option.value === canonical.value);
          if (!match) {
            match = canonical.cloneNode(true);
            select.append(match);
          }
        }
        if (!match) {
          match = options.find((option) => normalizeValue(option.textContent) === normalized);
        }
        if (!match) {
          match = new Option(raw, raw);
          select.append(match);
        }
        return match;
      };

      const setSelectValues = (select, values) => {
        select.querySelector('[data-ff-pf-multiple]')?.remove();
        const entries = [];
        values.forEach((value) => {
          const option = resolveOption(select, value);
          if (!option || entries.some((entry) => entry.value === option.value)) return;
          entries.push({ value: option.value, label: option.textContent.trim() });
        });
        selectedValues.set(select, entries);
        if (entries.length < 2) {
          select.value = entries[0]?.value || '';
          return;
        }
        let combinedValue = `ff-pf-multiple:${select.id}`;
        while (Array.from(select.options).some((option) => option.value === combinedValue)) combinedValue += ':';
        const combined = new Option(entries.map((entry) => entry.label).join(' · '), combinedValue);
        combined.dataset.ffPfMultiple = 'true';
        select.append(combined);
        combined.selected = true;
      };

      const getSelected = () => {
        const selected = [];

        selects.forEach((select) => {
          (selectedValues.get(select) || []).forEach((entry) => {
            selected.push({
              type: 'select',
              id: select.id,
              name: select.name,
              value: entry.value,
              label: entry.label
            });
          });
        });

        toggles.forEach((toggle) => {
          if (!toggle.checked) return;

          const labelEl = form.querySelector(`label[for="${escapeSelector(toggle.id)}"]`) || toggle.closest('label');
          const label = labelEl ? labelEl.textContent.trim().replace(/\s+/g, ' ') : toggle.value;

          selected.push({
            type: 'toggle',
            id: toggle.id,
            name: toggle.name,
            value: toggle.value,
            label
          });
        });

        return selected;
      };

      const updateState = () => {
        const selected = getSelected();
        const count = selected.length;

        summary.innerHTML = '';

        if (!count) {
          const empty = document.createElement('p');
          empty.className = 'ff-plant-finder__summary-empty';
          empty.textContent = summaryEmpty;
          summary.append(empty);
        } else {
          const prefix = document.createElement('span');
          prefix.className = 'ff-plant-finder__summary-prefix';
          prefix.textContent = summaryPrefix;
          summary.append(prefix);

          const list = document.createElement('div');
          list.className = 'ff-plant-finder__chips';

          selected.forEach((item) => {
            const chip = document.createElement('button');
            chip.type = 'button';
            chip.className = 'ff-plant-finder__chip';
            chip.dataset.ffPfClearTarget = item.id;
            chip.dataset.ffPfClearValue = item.value;
            chip.setAttribute('aria-label', removeTemplate.replace('{label}', item.label));

            const chipText = document.createElement('span');
            chipText.textContent = item.label;

            const chipIcon = document.createElement('span');
            chipIcon.setAttribute('aria-hidden', 'true');
            chipIcon.textContent = '×';

            chip.append(chipText, chipIcon);
            list.append(chip);
          });

          summary.append(list);
        }

        submit.textContent = count
          ? (count === 1 ? submitOne : submitSelected).replace('{count}', String(count))
          : submitDefault;
      };

      const hydrateFromUrl = (source = window.location.href, correctUrl = true) => {
        const url = new URL(source, window.location.origin);
        const params = readUrlParams(url);
        let corrected = false;

        selects.forEach((select) => {
          const values = params.getAll(select.name);
          setSelectValues(select, values);
          const mappedValues = selectedValues.get(select).map((entry) => entry.value);
          if (mappedValues.length !== values.length || mappedValues.some((value, index) => value !== values[index])) {
            params.delete(select.name);
            mappedValues.forEach((value) => params.append(select.name, value));
            corrected = true;
          }
        });

        toggles.forEach((toggle) => {
          const values = params.getAll(toggle.name);
          toggle.checked = values.includes(toggle.value);
        });
        if (corrected && correctUrl) {
          url.search = params.toString();
          window.location.replace(url.toString());
        }
      };

      const buildUrl = () => {
        const baseUrl = root.dataset.ffPfBaseUrl || form.getAttribute('action') || window.location.pathname;
        const url = new URL(baseUrl, window.location.origin);
        const currentUrl = new URL(window.location.href);
        const sameCollection = url.origin === currentUrl.origin &&
          url.pathname.replace(/\/+$/, '') === currentUrl.pathname.replace(/\/+$/, '');
        const params = readUrlParams(sameCollection ? currentUrl : url);

        selects.forEach((select) => {
          if (select.name) params.delete(select.name);
        });
        toggles.forEach((toggle) => {
          if (!toggle.name) return;
          const retained = params.getAll(toggle.name).filter((value) => value !== toggle.value);
          params.delete(toggle.name);
          retained.forEach((value) => params.append(toggle.name, value));
        });
        ['page', 'section_id', 'sections'].forEach((name) => params.delete(name));

        getSelected().forEach((item) => {
          if (!item.name || !item.value) return;
          params.append(item.name, item.value);
        });

        url.search = params.toString();
        return url.toString();
      };


      const onLocalizationSubmit = (event) => {
        const localizationForm = event.target;
        const localeControl = event.submitter;
        if (!(localizationForm instanceof HTMLFormElement) ||
            !localeControl || !['locale_code', 'language_code'].includes(localeControl.name) ||
            !['en', 'de'].includes(localeControl.value) ||
            localizationForm.method.toLowerCase() !== 'post' ||
            localizationForm.querySelector('input[name="form_type"]')?.value !== 'localization') return;
        const action = new URL(localizationForm.action, window.location.origin);
        if (action.origin !== window.location.origin ||
            !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?localization\/?$/i.test(action.pathname)) return;
        const url = new URL(window.location.href);
        const params = readUrlParams(url);
        if (!Array.from(params.keys()).some((name) => name.startsWith('filter.'))) return;
        selects.forEach((select) => {
          const values = params.getAll(select.name);
          if (!values.length) return;
          const mappedValues = values.map((value) => {
            const option = canonicalOption(select, value);
            return option?.getAttribute(`data-ff-pf-${localeControl.value}-value`) || value;
          });
          if (mappedValues.every((value, index) => value === values[index])) return;
          params.delete(select.name);
          mappedValues.forEach((value) => params.append(select.name, value));
        });
        url.search = params.toString();
        let returnTo = localizationForm.querySelector('input[name="return_to"]');
        if (!returnTo) {
          returnTo = document.createElement('input');
          returnTo.type = 'hidden';
          returnTo.name = 'return_to';
          localizationForm.append(returnTo);
        }
        returnTo.value = url.pathname + url.search + url.hash;
      };

      let resetTimer = null;
      const onControlChange = (event) => {
        const control = event.currentTarget;
        if (control.matches('select') && !control.selectedOptions[0]?.hasAttribute('data-ff-pf-multiple')) {
          setSelectValues(control, control.value ? [control.value] : []);
        }
        updateState();
      };
      const onSummaryClick = (event) => {
        const clearButton = event.target.closest('[data-ff-pf-clear-target]');
        if (!clearButton) return;
        const target = root.querySelector(`#${escapeSelector(clearButton.dataset.ffPfClearTarget)}`);
        if (!target) return;
        if (target.matches('select')) {
          const remaining = (selectedValues.get(target) || [])
            .filter((entry) => entry.value !== clearButton.dataset.ffPfClearValue)
            .map((entry) => entry.value);
          setSelectValues(target, remaining);
        }
        else if (target.matches('input[type="checkbox"]')) target.checked = false;
        target.dispatchEvent(new Event('change', { bubbles: true }));
        target.focus({ preventScroll: true });
      };
      const onReset = () => {
        if (resetTimer !== null) clearTimeout(resetTimer);
        resetTimer = setTimeout(() => {
          resetTimer = null;
          selects.forEach((select) => setSelectValues(select, select.value ? [select.value] : []));
          updateState();
        }, 0);
      };
      const onFacetUpdate = (event) => {
        if (!event.detail?.url) return;
        const url = new URL(event.detail.url, window.location.origin);
        const base = new URL(root.dataset.ffPfBaseUrl || form.action, window.location.origin);
        if (url.origin !== base.origin || url.pathname !== base.pathname) return;
        hydrateFromUrl(url, false);
        updateState();
      };
      const onPopState = () => { hydrateFromUrl(); updateState(); };
      const onSubmit = (event) => {
        event.preventDefault();
        window.location.href = buildUrl();
      };
      controls.forEach((control) => control.addEventListener('change', onControlChange));
      summary.addEventListener('click', onSummaryClick);
      form.addEventListener('reset', onReset);
      form.addEventListener('submit', onSubmit);
      document.addEventListener('submit', onLocalizationSubmit, true);
      document.addEventListener('facet:update', onFacetUpdate);
      window.addEventListener('popstate', onPopState);
      hydrateFromUrl();
      updateState();
      registerCleanup(root, () => {
        controls.forEach((control) => control.removeEventListener('change', onControlChange));
        summary.removeEventListener('click', onSummaryClick);
        form.removeEventListener('reset', onReset);
        form.removeEventListener('submit', onSubmit);
        document.removeEventListener('submit', onLocalizationSubmit, true);
        document.removeEventListener('facet:update', onFacetUpdate);
        window.removeEventListener('popstate', onPopState);
        if (resetTimer !== null) clearTimeout(resetTimer);
        delete root.dataset.ffPfReady;
      });
    });
  }


  /* Shopify editor + dynamic markup: accessible timeline tabs */
  function initFfOrderPerksTabs(scope) {
    qsa(scope, '[data-ff-order-perks]').forEach((root) => {
      if (root.dataset.ffOrderPerksReady === 'true') return;
      const tabs = Array.from(root.querySelectorAll('[data-ff-order-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-ff-order-panel]'));
      if (!tabs.length || tabs.length !== panels.length) return;
      root.dataset.ffOrderPerksReady = 'true';
      const section = root.closest('.shopify-section') || root;
      const activate = (index, focusTab = false) => {
        const nextIndex = (index + tabs.length) % tabs.length;

        tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === nextIndex;

          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });

        panels.forEach((panel, panelIndex) => {
          panel.hidden = panelIndex !== nextIndex;
        });

        const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        tabs[nextIndex].scrollIntoView({
          block: 'nearest',
          inline: 'center',
          behavior: reduceMotion ? 'auto' : 'smooth'
        });

        if (focusTab) {
          tabs[nextIndex].focus({ preventScroll: true });
        }
      };


      const handlers = [];
      tabs.forEach((tab, index) => {
        const onClick = () => activate(index);
        const onKeydown = (event) => {
          let currentIndex = tabs.findIndex((item) => item.getAttribute('aria-selected') === 'true');
          if (currentIndex < 0) currentIndex = index;
          if (event.key === 'ArrowRight') { event.preventDefault(); activate(currentIndex + 1, true); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); activate(currentIndex - 1, true); }
          if (event.key === 'Home') { event.preventDefault(); activate(0, true); }
          if (event.key === 'End') { event.preventDefault(); activate(tabs.length - 1, true); }
        };
        tab.addEventListener('click', onClick);
        tab.addEventListener('keydown', onKeydown);
        handlers.push(() => { tab.removeEventListener('click', onClick); tab.removeEventListener('keydown', onKeydown); });
      });
      const onBlockSelect = (event) => {
        if (!section.contains(event.target)) return;
        const selectedPanel = event.target.closest('[data-ff-order-panel]');
        const panelIndex = panels.indexOf(selectedPanel);
        if (panelIndex >= 0) activate(panelIndex);
      };
      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:block:select', onBlockSelect);
      }
      registerCleanup(root, () => {
        handlers.forEach((cleanup) => cleanup());
        if (window.Shopify && window.Shopify.designMode) {
          document.removeEventListener('shopify:block:select', onBlockSelect);
        }
        delete root.dataset.ffOrderPerksReady;
      });
    });
  }

  /* ========== INIT / HOOKS ========== */

function initAll(root) {
  root = root || document;
  initFfLazyModals();
  sortFfShippingPolicyTables(root);
  wrapProseTables(root);
  markFfPresentationShells(root);
  initFfRecentlyViewedSections(root);
  initFfDeferredSecondaryImages(root);
  initFfProductCardTapReveal();
  initFfLightParallax(root);
  initFfTabs(root);
  initFfAccordions(root);
  initFfAnnouncementBars(root);
  initFfPlantFinderForms(root);
  initFfOrderPerksTabs(root);
  initFfHeader(root);
  initFfMainProduct(root);
  initFfProductGalleryA11y(root);
  initFfQuantityLimits(root);
  initFfBackToTop(root);
  initFfQuickAccess(root);
  initFfTabsParallax(root);
  initFfParallaxMultiColumn(root);
  initFfCareBlog(root);
  initFfRichTextCollapsibles(root);
  initFfNewsletterPopupSuccess(root);
  initFfHeaderSidebarAccordions(root);
  initFfCollectionDescriptionCollapsibles(root);
  initFfCollectionBanners(root);
  initFfImageTextParallax(root);
  initFfScrollStory(root);
  initFfFilterModals(root);
  initFfInlineActionHelpers(root);
  initFfPageUtilities(root);
}

  window.FF = window.FF || {};
  window.FF.initFfUI = initAll;

  // Initial load
  if (document.readyState === "interactive" || document.readyState === "complete") {
    initAll(document);
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  }

  // Shopify editor section reload
  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    runCleanup(event.target);
  });

  // Catch dynamic injections (product rerender swaps, cart drawer refresh, etc.)
  let scheduled = false;
  let pendingRoots = new Set();

  function normalizePendingRoots(roots) {
    if (!roots.length) return roots;
    if (roots.includes(document)) return [document];

    return roots.filter((root, index) => {
      return !roots.some((candidate, candidateIndex) => {
        if (candidateIndex === index) return false;
        if (candidate === document) return true;
        return !!(candidate && candidate.contains && candidate.contains(root));
      });
    });
  }

  function scheduleFlush() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      const roots = normalizePendingRoots(Array.from(pendingRoots));
      pendingRoots.clear();
      roots.forEach((r) => initAll(r));
    });
  }

  const mo = new MutationObserver(function (mutations) {
    mutations.forEach((m) => {
      m.addedNodes.forEach((node) => {
        collectInitRoot(node, pendingRoots);
      });

      m.removedNodes.forEach((node) => {
        if (nodeMatchesOrContains(node, "[data-ff-cleanup-root]")) runCleanup(node);
      });
    });

    if (pendingRoots.size) scheduleFlush();
  });

  function startObserver() {
    if (!document.body) return;
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.body) startObserver();
  else document.addEventListener("DOMContentLoaded", startObserver);
})();

(function () {
  var storageKey = 'ff_itrk_trust_widget_hidden_session';
  var buttonId = 'ff-itrk-widget-close';

  function isHidden() {
    try {
      return window.sessionStorage.getItem(storageKey) === '1';
    } catch (error) {
      return false;
    }
  }

  function hideWidget() {
    document.documentElement.classList.add('ff-itrk-widget-hidden');

    var widget = document.getElementById('itrk-main-widget-container');

    if (widget) {
      widget.style.setProperty('display', 'none', 'important');
    }
  }

  function installButton() {
    var widget = document.getElementById('itrk-main-widget-container');
    var isGerman = (document.documentElement.lang || '')
      .toLowerCase()
      .indexOf('de') === 0;
    var closeLabel = isGerman
      ? 'Trust-Widget ausblenden'
      : 'Hide legal trust widget';
    var openLabel = isGerman
      ? 'Rechtliches Prüfsiegel öffnen'
      : 'Open legal trust certificate';

    if (!widget) {
      return false;
    }

    widget.lang = isGerman ? 'de' : 'en';

    var certificateLink = widget.querySelector('a[href]');
    if (certificateLink) {
      certificateLink.setAttribute('aria-label', openLabel);
      certificateLink.title = openLabel;
      certificateLink.setAttribute('rel', 'noopener noreferrer');
    }

    if (isHidden()) {
      hideWidget();
      return true;
    }

    if (document.getElementById(buttonId)) {
      return true;
    }

    var button = document.createElement('button');

    button.id = buttonId;
    button.type = 'button';
    button.textContent = '×';
    button.setAttribute('aria-label', closeLabel);
    button.title = closeLabel;

    button.addEventListener(
      'click',
      function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        try {
          window.sessionStorage.setItem(storageKey, '1');
        } catch (error) {}

        hideWidget();
      },
      true
    );

    widget.appendChild(button);

    return true;
  }

  function init() {
    installButton();

    var observer = new MutationObserver(function () {
      installButton();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  'use strict';

  var storageKey = 'ff_google_store_widget_hidden_session';
  var buttonId = 'ff-google-widget-close';
  var wrapperId = 'google-merchantwidget-iframe-wrapper';
  var frameAttribute = 'data-ff-google-store-widget';
  var compactWidthLimit = 160;
  var fallbackDelay = 8000;
  var scanScheduled = false;
  var fallbackTimer = null;
  var resizeObserver = null;
  var wrapperMutationObserver = null;
  var observedWrapper = null;
  var widestWrapper = 0;
  var secondStateReached = false;

  function isHidden() {
    try {
      return window.sessionStorage.getItem(storageKey) === '1';
    } catch (error) {
      return false;
    }
  }

  function findWrapper() {
    return document.getElementById(wrapperId);
  }

  function findFrame(wrapper) {
    if (!wrapper) return null;

    return wrapper.querySelector(
      'iframe#merchantwidgetiframe, iframe[src*="shopping/merchantverse"]'
    );
  }

  function setReady(isReady) {
    var root = document.documentElement;
    if (root.classList.contains('ff-google-widget-ready') !== isReady) {
      root.classList.toggle('ff-google-widget-ready', isReady);
    }
  }

  function setStyle(element, property, value) {
    if (element.style.getPropertyValue(property) !== value ||
        element.style.getPropertyPriority(property) !== 'important') {
      element.style.setProperty(property, value, 'important');
    }
  }

  function markFrame(frame) {
    if (frame && frame.getAttribute(frameAttribute) !== 'true') {
      frame.setAttribute(frameAttribute, 'true');
    }
  }

  function hideWidget() {
    window.clearTimeout(fallbackTimer);
    fallbackTimer = null;
    setReady(false);
    document.documentElement.classList.add('ff-google-widget-hidden');

    var wrapper = findWrapper();
    var frame = findFrame(wrapper);

    if (wrapper) setStyle(wrapper, 'display', 'none');

    if (frame) {
      markFrame(frame);
      setStyle(frame, 'display', 'none');
    }
  }

  function installButton() {
    var existing = document.getElementById(buttonId);
    if (existing) return existing;
    if (!document.body) return null;

    var button = document.createElement('button');
    var isGerman = (document.documentElement.lang || '')
      .toLowerCase()
      .indexOf('de') === 0;
    var label = isGerman
      ? 'Google-Widget ausblenden'
      : 'Hide Google widget';

    button.id = buttonId;
    button.type = 'button';
    button.textContent = '×';
    button.setAttribute('aria-label', label);
    button.title = label;

    button.addEventListener(
      'click',
      function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        try {
          window.sessionStorage.setItem(storageKey, '1');
        } catch (error) {}

        hideWidget();
      },
      true
    );

    document.body.appendChild(button);
    return button;
  }

  function positionGoogleClose(rect, button) {
    if (!rect.width || !rect.height) return;

    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    var closeSize = isMobile ? 16 : 18;

    /* Google's visible button is inset inside its clipping wrapper. */
    var googleRight = rect.right - 12;
    var googleTop = rect.top + 12;

    setStyle(button, 'left', googleRight - closeSize / 2 + 'px');
    setStyle(button, 'top', googleTop - closeSize / 2 + 'px');
    setStyle(button, 'right', 'auto');
    setStyle(button, 'bottom', 'auto');
  }

  function measureState(width) {
    if (!width) return;

    widestWrapper = Math.max(widestWrapper, width);

    if (
      width <= compactWidthLimit &&
      widestWrapper - width > 4
    ) {
      secondStateReached = true;
      window.clearTimeout(fallbackTimer);
      fallbackTimer = null;
    }

    setReady(secondStateReached && width <= compactWidthLimit);
  }

  function scheduleFallbackReveal() {
    if (fallbackTimer || secondStateReached) return;

    fallbackTimer = window.setTimeout(function () {
      fallbackTimer = null;

      var wrapper = findWrapper();
      if (
        !isHidden() &&
        wrapper &&
        wrapper.getBoundingClientRect().width <= compactWidthLimit
      ) {
        secondStateReached = true;
        scheduleScan();
      }
    }, fallbackDelay);
  }

  function observeWrapper(wrapper) {
    if (observedWrapper === wrapper) return;

    if (resizeObserver) resizeObserver.disconnect();
    if (wrapperMutationObserver) wrapperMutationObserver.disconnect();

    observedWrapper = wrapper;
    widestWrapper = 0;
    secondStateReached = false;
    window.clearTimeout(fallbackTimer);
    fallbackTimer = null;
    setReady(false);

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(scheduleScan);
      resizeObserver.observe(wrapper);
    }

    wrapperMutationObserver = new MutationObserver(scheduleScan);
    wrapperMutationObserver.observe(wrapper, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  function scan() {
    scanScheduled = false;

    var wrapper = findWrapper();
    if (!wrapper) return;

    if (isHidden()) {
      hideWidget();
      return;
    }

    // Read geometry once, before any class, attribute or style writes.
    var rect = wrapper.getBoundingClientRect();
    observeWrapper(wrapper);
    markFrame(findFrame(wrapper));
    measureState(rect.width);

    var button = installButton();
    if (!button) return;

    /* Keep the close control above Google's equal-z-index wrapper.
       Unrelated body additions do not require moving it again. */
    if (button.parentNode !== document.body ||
        !(wrapper.compareDocumentPosition(button) & Node.DOCUMENT_POSITION_FOLLOWING)) {
      document.body.appendChild(button);
    }

    positionGoogleClose(rect, button);
    scheduleFallbackReveal();
  }

  function scheduleScan() {
    if (scanScheduled) return;
    scanScheduled = true;
    window.requestAnimationFrame(scan);
  }

  function init() {
    if (isHidden()) {
      document.documentElement.classList.add('ff-google-widget-hidden');
    }

    var observer = new MutationObserver(function (mutations) {
      var wrapper = findWrapper();
      if (!wrapper) return;
      var button = document.getElementById(buttonId);
      if (wrapper !== observedWrapper || !button ||
          button.parentNode !== document.body) {
        scheduleScan();
        return;
      }

      // A moved wrapper can change paint order without changing identity.
      if (!(wrapper.compareDocumentPosition(button) & Node.DOCUMENT_POSITION_FOLLOWING)) {
        scheduleScan();
        return;
      }

      // Wrapper content, size, style and viewport changes still trigger scans.
      // Ignore unrelated body siblings; wrapper changes are handled above.
      if (mutations.some(function (mutation) {
        return wrapper.contains(mutation.target);
      })) scheduleScan();
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.addEventListener('resize', scheduleScan, { passive: true });

    // Scroll locking can move fixed widgets without a window resize.
    // Watch root width only; unrelated page-height changes need no scan.
    if ('ResizeObserver' in window) {
      var rootWidth = null;
      var viewportObserver = new ResizeObserver(function (entries) {
        var width = entries[0].contentRect.width;
        if (rootWidth !== null && width !== rootWidth) scheduleScan();
        rootWidth = width;
      });
      viewportObserver.observe(document.documentElement);
    }

    scan();
    window.setTimeout(scan, 1000);
    window.setTimeout(scan, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  'use strict';
  return;

  var root = document.documentElement;
  var isGerman = (root.lang || '').toLowerCase().indexOf('de') === 0;
  var labels = isGerman
    ? {
        closeGoogle: 'Google-Shopbewertung schließen',
        closeLegal: 'Rechtliches Prüfsiegel schließen',
        openLegal: 'Rechtliches Prüfsiegel öffnen'
      }
    : {
        closeGoogle: 'Close Google store rating',
        closeLegal: 'Close legal trust certificate',
        openLegal: 'Open legal trust certificate'
      };
  var consentSelectors =
    '.consent-studio .cookie-banner, .consent-studio .cookie-list';
  var consentObservers = [];
  var itrkObserver = null;
  var googleObserver = null;
  var googleResizeObserver = null;
  var discoveryObserver = null;

  function consentIsOpen() {
    return Array.from(document.querySelectorAll(consentSelectors)).some(function (node) {
      return !node.classList.contains('is--hidden');
    });
  }

  function setWidgetAvailability(element, available) {
    if (!element) return;
    element.setAttribute('aria-hidden', available ? 'false' : 'true');

    try {
      element.inert = !available;
    } catch (error) {}
  }

  function syncConsentLayer() {
    var isOpen = consentIsOpen();
    root.classList.toggle('ff-consent-layer-open', isOpen);

    setWidgetAvailability(
      document.getElementById('itrk-main-widget-container'),
      !isOpen
    );
    setWidgetAvailability(
      document.getElementById('google-merchantwidget-iframe-wrapper'),
      !isOpen
    );
  }

  function observeConsentNodes() {
    document.querySelectorAll(consentSelectors).forEach(function (node) {
      if (node.dataset.ffConsentLayerObserved === 'true') return;
      node.dataset.ffConsentLayerObserved = 'true';

      var observer = new MutationObserver(syncConsentLayer);
      observer.observe(node, {
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden']
      });
      consentObservers.push(observer);
    });

    syncConsentLayer();
  }

  function legalWidgetExpanded(widget) {
    return widget && widget.classList.contains('widget-expanded');
  }

  function syncLegalExpanded(widget) {
    var expanded = legalWidgetExpanded(widget);
    root.classList.toggle('ff-itrk-widget-expanded', expanded);

    if (expanded) root.classList.remove('ff-google-widget-expanded');
  }

  function hideLegalWidget(widget) {
    try {
      window.sessionStorage.setItem('ff_itrk_trust_widget_hidden_session', '1');
    } catch (error) {}

    root.classList.add('ff-itrk-widget-hidden');
    if (widget) widget.hidden = true;
  }

  function enhanceLegalWidget() {
    var widget = document.getElementById('itrk-main-widget-container');
    if (!widget || widget.dataset.ffWidgetEnhanced === 'true') return Boolean(widget);

    widget.dataset.ffWidgetEnhanced = 'true';
    widget.lang = isGerman ? 'de' : 'en';

    var certificateLink = widget.querySelector('a[href]');
    if (certificateLink) {
      certificateLink.setAttribute('aria-label', labels.openLegal);
      certificateLink.title = labels.openLegal;
      certificateLink.setAttribute('rel', 'noopener noreferrer');
    }

    var close = document.createElement('button');
    close.id = 'ff-itrk-widget-close';
    close.type = 'button';
    close.className = 'ff-floating-widget-close';
    close.setAttribute('aria-label', labels.closeLegal);
    close.title = labels.closeLegal;
    close.innerHTML = '<span aria-hidden="true">×</span>';
    close.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      hideLegalWidget(widget);
    });
    widget.appendChild(close);

    try {
      if (
        window.sessionStorage.getItem('ff_itrk_trust_widget_hidden_session') === '1'
      ) {
        hideLegalWidget(widget);
      }
    } catch (error) {}

    itrkObserver = new MutationObserver(function () {
      syncLegalExpanded(widget);
    });
    itrkObserver.observe(widget, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    syncLegalExpanded(widget);
    syncConsentLayer();
    return true;
  }

  function hideGoogleWidget(wrapper) {
    try {
      window.sessionStorage.setItem(
        'ff_google_store_widget_hidden_session',
        '1'
      );
    } catch (error) {}

    root.classList.add('ff-google-widget-hidden');
    if (wrapper) wrapper.hidden = true;
  }

  function syncGoogleExpanded(wrapper) {
    if (!wrapper || wrapper.hidden) {
      root.classList.remove('ff-google-widget-expanded');
      return;
    }

    var rect = wrapper.getBoundingClientRect();
    var expanded = rect.width > 180 || rect.height > 110;
    root.classList.toggle('ff-google-widget-expanded', expanded);

    if (expanded) root.classList.remove('ff-itrk-widget-expanded');
  }

  function enhanceGoogleWidget(wrapper) {
    wrapper = wrapper || document.getElementById('google-merchantwidget-iframe-wrapper');
    if (!wrapper || wrapper.dataset.ffWidgetEnhanced === 'true') return;
    wrapper.dataset.ffWidgetEnhanced = 'true';

    var frame = wrapper.querySelector('iframe');
    if (frame) {
      frame.title = 'Google store rating';
      frame.dataset.ffGoogleStoreWidget = 'true';
    }

    var close = document.createElement('button');
    close.id = 'ff-google-widget-close';
    close.type = 'button';
    close.className = 'ff-floating-widget-close';
    close.setAttribute('aria-label', labels.closeGoogle);
    close.title = labels.closeGoogle;
    close.innerHTML = '<span aria-hidden="true">×</span>';
    close.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      hideGoogleWidget(wrapper);
    });
    wrapper.appendChild(close);

    try {
      if (
        window.sessionStorage.getItem('ff_google_store_widget_hidden_session') ===
        '1'
      ) {
        hideGoogleWidget(wrapper);
      }
    } catch (error) {}

    googleObserver = new MutationObserver(function () {
      syncGoogleExpanded(wrapper);
    });
    googleObserver.observe(wrapper, {
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden']
    });

    if ('ResizeObserver' in window) {
      googleResizeObserver = new ResizeObserver(function () {
        requestAnimationFrame(function () {
          syncGoogleExpanded(wrapper);
        });
      });
      googleResizeObserver.observe(wrapper);
    }

    syncGoogleExpanded(wrapper);
    syncConsentLayer();
  }

  function scanForInjectedUi() {
    observeConsentNodes();
    var legalReady = enhanceLegalWidget();

    var google = document.getElementById('google-merchantwidget-iframe-wrapper');
    if (google) enhanceGoogleWidget(google);

    if (
      legalReady &&
      document.querySelectorAll(consentSelectors).length &&
      discoveryObserver
    ) {
      discoveryObserver.disconnect();
      discoveryObserver = null;
    }
  }

  function init() {
    scanForInjectedUi();

    if (document.body && (!document.getElementById('itrk-main-widget-container') ||
        !document.querySelectorAll(consentSelectors).length)) {
      discoveryObserver = new MutationObserver(scanForInjectedUi);
      discoveryObserver.observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener('ff:google-widget-ready', function (event) {
      enhanceGoogleWidget(event.detail && event.detail.wrapper);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

(function () {
  'use strict';

  var root = document.documentElement;
  var selectors = '.consent-studio .cookie-banner, .consent-studio .cookie-list';
  var observer = null;

  function consentIsOpen() {
    return Array.from(document.querySelectorAll(selectors)).some(function (node) {
      return !node.classList.contains('is--hidden');
    });
  }

  function setAvailability(element, available) {
    if (!element) return;
    var hidden = available ? 'false' : 'true';
    if (element.getAttribute('aria-hidden') !== hidden) {
      element.setAttribute('aria-hidden', hidden);
    }

    try {
      if (element.inert !== !available) element.inert = !available;
    } catch (error) {}
  }

  function sync() {
    var isOpen = consentIsOpen();
    if (root.classList.contains('ff-consent-layer-open') !== isOpen) {
      root.classList.toggle('ff-consent-layer-open', isOpen);
    }
    setAvailability(
      document.getElementById('itrk-main-widget-container'),
      !isOpen
    );
    setAvailability(
      document.getElementById('google-merchantwidget-iframe-wrapper'),
      !isOpen
    );
  }


  // Only consent membership/state and widget discovery need a document scan.
  // Inspect changed subtrees so late insertion, removal and reparenting work.
  var relevantSelectors = '.consent-studio, .cookie-banner, .cookie-list, ' +
    '#itrk-main-widget-container, #google-merchantwidget-iframe-wrapper';
  var relevantClasses = /(^|\s)(consent-studio|cookie-banner|cookie-list)(\s|$)/;

  function hasRelevantNode(node) {
    return node.nodeType === 1 &&
      (node.matches(relevantSelectors) || node.querySelector(relevantSelectors));
  }

  function affectsConsentLayer(record) {
    if (record.type === 'attributes') {
      if (record.target.matches(relevantSelectors)) return true;
      if (record.attributeName === 'class') {
        // Retain removals of a selector class, including an ancestor container.
        if (relevantClasses.test(record.oldValue || '')) return true;
        if (record.target === root) {
          return /(^|\s)ff-consent-layer-open(\s|$)/.test(record.oldValue || '') !==
            root.classList.contains('ff-consent-layer-open');
        }
      }
      if (record.attributeName === 'id') {
        return record.oldValue === 'itrk-main-widget-container' ||
          record.oldValue === 'google-merchantwidget-iframe-wrapper';
      }
      return false;
    }
    return Array.prototype.some.call(record.addedNodes, hasRelevantNode) ||
      Array.prototype.some.call(record.removedNodes, hasRelevantNode);
  }

  function init() {
    sync();

    observer = new MutationObserver(function (records) {
      if (records.some(affectsConsentLayer)) sync();
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'id'],
      attributeOldValue: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

(function () {
  'use strict';

  if (document.documentElement.dataset.ffPageType !== 'product') return;

  document.addEventListener('submit', function (event) {
    const form = event.target;
    const control = event.submitter;
    if (!(form instanceof HTMLFormElement) ||
        !control || !['locale_code', 'language_code'].includes(control.name) ||
        form.method.toLowerCase() !== 'post' ||
        form.querySelector('input[name="form_type"]')?.value !== 'localization') return;

    const action = new URL(form.action, window.location.origin);
    if (action.origin !== window.location.origin ||
        !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?localization\/?$/i.test(action.pathname)) return;

    const current = new URL(window.location.href);
    if (!/^\d+$/.test(current.searchParams.get('variant') || '')) return;

    let returnTo = form.querySelector('input[name="return_to"]');
    if (!returnTo) {
      returnTo = document.createElement('input');
      returnTo.type = 'hidden';
      returnTo.name = 'return_to';
      form.append(returnTo);
    }
    returnTo.value = current.pathname + current.search + current.hash;
  }, true);
})();
